function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "0%",
  y1: "100%",
  x2: "100%",
  y2: "100%",
  id: "step-section-estate_svg__c"
}, React.createElement("stop", {
  stopColor: "#E7C7CD",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#9FACA8",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "3.525%",
  y1: "105.869%",
  x2: "101.434%",
  y2: "55.15%",
  id: "step-section-estate_svg__d"
}, React.createElement("stop", {
  stopColor: "#E7C7CD",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#9FACA8",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "100%",
  x2: "100%",
  y2: "100%",
  id: "step-section-estate_svg__e"
}, React.createElement("stop", {
  stopColor: "#008A90",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#016879",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "100%",
  x2: "100%",
  y2: "100%",
  id: "step-section-estate_svg__f"
}, React.createElement("stop", {
  stopColor: "#008A90",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#008083",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "100.01%",
  x2: "100%",
  y2: "100.01%",
  id: "step-section-estate_svg__g"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "122.73%",
  y1: "7.64%",
  x2: "31.061%",
  y2: "3.481%",
  id: "step-section-estate_svg__h"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "100%",
  x2: "100%",
  y2: "100%",
  id: "step-section-estate_svg__i"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "100.304%",
  y1: "99.672%",
  x2: "99.279%",
  y2: "-.44%",
  id: "step-section-estate_svg__j"
}, React.createElement("stop", {
  stopColor: "#008A90",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#016879",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "100.306%",
  y1: "99.672%",
  x2: "99.281%",
  y2: "-.44%",
  id: "step-section-estate_svg__k"
}, React.createElement("stop", {
  stopColor: "#008A90",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#016879",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "99.997%",
  x2: "99.999%",
  y2: "99.997%",
  id: "step-section-estate_svg__l"
}, React.createElement("stop", {
  stopColor: "#008A90",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#016879",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "100%",
  x2: "100%",
  y2: "100%",
  id: "step-section-estate_svg__m"
}, React.createElement("stop", {
  stopColor: "#98BFDC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#7498DF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "99.999%",
  x2: "100%",
  y2: "99.999%",
  id: "step-section-estate_svg__n"
}, React.createElement("stop", {
  stopColor: "#98BFDC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#7498DF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-149.514%",
  y1: "171.813%",
  x2: "222.806%",
  y2: "194.934%",
  id: "step-section-estate_svg__o"
}, React.createElement("stop", {
  stopColor: "#98BFDC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FFF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-574.669%",
  y1: "779.332%",
  x2: "795.786%",
  y2: "779.206%",
  id: "step-section-estate_svg__p"
}, React.createElement("stop", {
  stopColor: "#98BFDC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#7498DF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-93.95%",
  y1: "-405.481%",
  x2: "-1102.198%",
  y2: "-241.532%",
  id: "step-section-estate_svg__q"
}, React.createElement("stop", {
  stopColor: "#98BFDC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FFF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-37.355%",
  y1: "62.975%",
  x2: "118.708%",
  y2: "98.228%",
  id: "step-section-estate_svg__r"
}, React.createElement("stop", {
  stopColor: "#98BFDC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#7498DF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-347.649%",
  y1: "1487.684%",
  x2: "2470.359%",
  y2: "1481.503%",
  id: "step-section-estate_svg__s"
}, React.createElement("stop", {
  stopColor: "#98BFDC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FFF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "243.162%",
  y1: "761.599%",
  x2: "826.795%",
  y2: "-853.428%",
  id: "step-section-estate_svg__t"
}, React.createElement("stop", {
  stopColor: "#98BFDC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FFF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "199.587%",
  y1: "5.548%",
  x2: "59.452%",
  y2: "-232.86%",
  id: "step-section-estate_svg__u"
}, React.createElement("stop", {
  stopColor: "#98BFDC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#7498DF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-166.695%",
  y1: "203.651%",
  x2: "258.609%",
  y2: "216.663%",
  id: "step-section-estate_svg__v"
}, React.createElement("stop", {
  stopColor: "#98BFDC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#7498DF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-120.524%",
  y1: "61.786%",
  x2: "46.558%",
  y2: "283.595%",
  id: "step-section-estate_svg__w"
}, React.createElement("stop", {
  stopColor: "#98BFDC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#7498DF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-141.621%",
  y1: "42.423%",
  x2: "-62.072%",
  y2: "349.758%",
  id: "step-section-estate_svg__x"
}, React.createElement("stop", {
  stopColor: "#98BFDC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#7498DF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "43.207%",
  y1: "99.813%",
  x2: "68.012%",
  y2: "58.609%",
  id: "step-section-estate_svg__y"
}, React.createElement("stop", {
  stopColor: "#98BFDC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#7498DF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-15.303%",
  y1: "65.618%",
  x2: "40.857%",
  y2: "92.772%",
  id: "step-section-estate_svg__z"
}, React.createElement("stop", {
  stopColor: "#98BFDC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#7498DF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "295.71%",
  y1: "246.66%",
  x2: "294.915%",
  y2: "-239.967%",
  id: "step-section-estate_svg__A"
}, React.createElement("stop", {
  stopColor: "#98BFDC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#7498DF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "335.612%",
  y1: "273.12%",
  x2: "328.899%",
  y2: "-287.005%",
  id: "step-section-estate_svg__B"
}, React.createElement("stop", {
  stopColor: "#98BFDC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#7498DF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "35.274%",
  y1: "119.298%",
  x2: "70.421%",
  y2: "75.529%",
  id: "step-section-estate_svg__C"
}, React.createElement("stop", {
  stopColor: "#98BFDC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#7498DF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "27.776%",
  y1: "73.447%",
  x2: "57.272%",
  y2: "140.478%",
  id: "step-section-estate_svg__D"
}, React.createElement("stop", {
  stopColor: "#98BFDC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FFF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "44.184%",
  y1: "184.277%",
  x2: "114.45%",
  y2: "72.3%",
  id: "step-section-estate_svg__E"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "108.77%",
  y1: "114.793%",
  x2: "95.442%",
  y2: "18.193%",
  id: "step-section-estate_svg__F"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-.01%",
  y1: "100.01%",
  x2: "100.014%",
  y2: "100.01%",
  id: "step-section-estate_svg__G"
}, React.createElement("stop", {
  stopColor: "#008A90",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#016879",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "100.006%",
  x2: "100.011%",
  y2: "100.006%",
  id: "step-section-estate_svg__H"
}, React.createElement("stop", {
  stopColor: "#008A90",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#008083",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: ".35%",
  y1: "222.413%",
  x2: "197.619%",
  y2: "94.914%",
  id: "step-section-estate_svg__I"
}, React.createElement("stop", {
  stopColor: "#008A90",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#016879",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-.002%",
  y1: "99.987%",
  x2: "99.999%",
  y2: "99.987%",
  id: "step-section-estate_svg__J"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "16.83%",
  y1: "112.614%",
  x2: "123.239%",
  y2: "105.483%",
  id: "step-section-estate_svg__K"
}, React.createElement("stop", {
  stopColor: "#6C90BD",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#564D89",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-21.429%",
  y1: "79.334%",
  x2: "86.216%",
  y2: "104.354%",
  id: "step-section-estate_svg__L"
}, React.createElement("stop", {
  stopColor: "#6C90BD",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#7498DF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "8.483%",
  y1: "9.718%",
  x2: "-9.09%",
  y2: "87.499%",
  id: "step-section-estate_svg__M"
}, React.createElement("stop", {
  stopColor: "#98BFDC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#7498DF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "100.306%",
  y1: "99.672%",
  x2: "99.279%",
  y2: "-.44%",
  id: "step-section-estate_svg__N"
}, React.createElement("stop", {
  stopColor: "#008A90",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#016879",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "98.466%",
  y1: "76.925%",
  x2: "96.231%",
  y2: "-19.878%",
  id: "step-section-estate_svg__O"
}, React.createElement("stop", {
  stopColor: "#008A90",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#008083",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-22.875%",
  y1: "32.992%",
  x2: "10.153%",
  y2: "131.901%",
  id: "step-section-estate_svg__P"
}, React.createElement("stop", {
  stopColor: "#008A90",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#016879",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "81.247%",
  y1: "116.721%",
  x2: "101.344%",
  y2: "18.814%",
  id: "step-section-estate_svg__Q"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: ".002%",
  y1: "99.987%",
  x2: "100.002%",
  y2: "99.987%",
  id: "step-section-estate_svg__R"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "99.992%",
  x2: "100.003%",
  y2: "99.992%",
  id: "step-section-estate_svg__S"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "99.987%",
  x2: "100%",
  y2: "99.987%",
  id: "step-section-estate_svg__T"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: ".004%",
  y1: "99.992%",
  x2: "100.003%",
  y2: "99.992%",
  id: "step-section-estate_svg__U"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-.009%",
  y1: "100.019%",
  x2: "99.994%",
  y2: "100.019%",
  id: "step-section-estate_svg__V"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-.002%",
  y1: "99.987%",
  x2: "99.999%",
  y2: "99.987%",
  id: "step-section-estate_svg__W"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "99.998%",
  x2: "100.003%",
  y2: "99.998%",
  id: "step-section-estate_svg__X"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-.009%",
  y1: "100.014%",
  x2: "99.994%",
  y2: "100.014%",
  id: "step-section-estate_svg__Y"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "99.992%",
  x2: "100.002%",
  y2: "99.992%",
  id: "step-section-estate_svg__Z"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: ".002%",
  y1: "99.988%",
  x2: "100.003%",
  y2: "99.988%",
  id: "step-section-estate_svg__aa"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "99.992%",
  x2: "100.001%",
  y2: "99.992%",
  id: "step-section-estate_svg__ab"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "7.22%",
  y1: "100.48%",
  x2: "101.514%",
  y2: "60.394%",
  id: "step-section-estate_svg__ac"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "99.975%",
  x2: "99.998%",
  y2: "99.975%",
  id: "step-section-estate_svg__ad"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-.008%",
  y1: "100.002%",
  x2: "99.992%",
  y2: "100.002%",
  id: "step-section-estate_svg__ae"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-.013%",
  y1: "100.006%",
  x2: "99.992%",
  y2: "100.006%",
  id: "step-section-estate_svg__af"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "114.112%",
  y1: "129.77%",
  x2: "125.492%",
  y2: "-10.397%",
  id: "step-section-estate_svg__ag"
}, React.createElement("stop", {
  stopColor: "#006C5D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#00986D",
  offset: "100%"
})), React.createElement("filter", {
  x: "-8.5%",
  y: "-10.4%",
  width: "119.2%",
  height: "130.1%",
  filterUnits: "objectBoundingBox",
  id: "step-section-estate_svg__a"
}, React.createElement("feOffset", {
  dx: 8,
  dy: 22,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 20,
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.269664116 0 0 0 0 0.257130012 0 0 0 0 0.257130012 0 0 0 0.5 0",
  "in": "shadowBlurOuter1"
})), React.createElement("path", {
  d: "M368.877 557.971c203.726 0 368.878-105.638 368.878-235.949S572.603 86.073 368.877 86.073C165.152 86.073 0 191.711 0 322.022s165.152 235.949 368.877 235.949z",
  id: "step-section-estate_svg__b"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fillRule: "nonzero",
  transform: "translate(31)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#step-section-estate_svg__a)",
  xlinkHref: "#step-section-estate_svg__b"
}), React.createElement("use", {
  fill: "#3CB694",
  xlinkHref: "#step-section-estate_svg__b"
})), React.createElement("path", {
  d: "M416.123 554.728c203.726 0 368.878-105.638 368.878-235.949 0-130.31-165.152-235.948-368.878-235.948-203.725 0-368.877 105.638-368.877 235.948 0 130.311 165.152 235.949 368.877 235.949z",
  fill: "#3CB694",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M720.444 453.278c-24.156 22.223-46.856 35.402-46.856 35.402L122.072 166.885s9.81-7.27 19.828-13.483c10.019-6.213 30.906-17.981 30.906-17.981l547.638 317.857zM487.908 551.315c-51.033 8.278-95.175 6.486-95.175 6.486L32.531 349.159s-4.508-36.182 2.211-60.929l453.166 263.085z",
  fill: "#F6E7DB",
  fillRule: "nonzero"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  d: "M326.57 459.467l-57.08-33.849 35.072-19.65 58.117 33.664z"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__c)",
  fillRule: "nonzero",
  d: "M240.617 424.85l32.776-18.882 57.691 33.835z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  d: "M386.184 259.558l-44.483-24.577 66.033-37.329 42.666 25.553zM483.91 320.401l-41.592-27.051 54.551-31.1 42.666 25.553zM188.69 378.599l-42.442-25.601 51.404-29.308 42.665 25.554z"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__d)",
  fillRule: "nonzero",
  d: "M134.385 342.076l31.991-18.443 42.686 25.525z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#F6E7DB",
  fillRule: "nonzero",
  d: "M95.51 323.667l36.023-20.162-12.866-7.691-35.784 20.538z"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__c)",
  fillRule: "nonzero",
  d: "M326.678 226.192l89.195-.88-43.508-25.169z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#005054",
  fillRule: "nonzero",
  d: "M189.578 378.094l80.658 46.729 1.908-1.014-80.93-46.645z"
}), React.createElement("path", {
  fill: "#005054",
  fillRule: "nonzero",
  d: "M270.512 425.02l32.645-18.368-1.176-.661-32.235 18.517zM82.882 316.39l35.469-20.395-1.278-.768-35.106 20.523zM175.676 328.849l-79.668-5.462 35.525-19.882zM415.91 497.81c6.647 0 12.035-3.629 12.035-8.106 0-4.478-5.388-8.107-12.035-8.107s-12.035 3.629-12.035 8.107c0 4.477 5.388 8.106 12.035 8.106zM273.105 409.404c6.647 0 12.035-3.629 12.035-8.106 0-4.478-5.388-8.107-12.035-8.107-6.646 0-12.035 3.629-12.035 8.107 0 4.477 5.389 8.106 12.035 8.106zM239.338 389.863c6.647 0 12.035-3.63 12.035-8.107 0-4.477-5.388-8.107-12.035-8.107s-12.035 3.63-12.035 8.107c0 4.477 5.388 8.107 12.035 8.107z"
}), React.createElement("path", {
  d: "M152.074 339.26c6.647 0 12.035-3.63 12.035-8.107 0-4.477-5.388-8.107-12.035-8.107s-12.035 3.63-12.035 8.107c0 4.477 5.388 8.107 12.035 8.107zM86.072 302.907c6.647 0 12.035-3.629 12.035-8.106 0-4.478-5.388-8.107-12.035-8.107s-12.035 3.629-12.035 8.107c0 4.477 5.388 8.106 12.035 8.106zM353.736 224.144c6.647 0 12.035-3.63 12.035-8.107 0-4.477-5.388-8.107-12.035-8.107s-12.035 3.63-12.035 8.107c0 4.477 5.388 8.107 12.035 8.107zM277.953 184.975c6.647 0 12.035-3.629 12.035-8.106 0-4.478-5.388-8.107-12.035-8.107s-12.035 3.629-12.035 8.107c0 4.477 5.388 8.106 12.035 8.106zM218.16 153.402c6.647 0 12.035-3.63 12.035-8.107 0-4.477-5.388-8.107-12.035-8.107s-12.035 3.63-12.035 8.107c0 4.477 5.388 8.107 12.035 8.107z",
  fill: "#005054",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M262.728 172.517c10.076 0 18.244-4.012 18.244-8.96 0-4.949-8.168-8.96-18.244-8.96s-18.244 4.011-18.244 8.96c0 4.948 8.168 8.96 18.244 8.96zM412.168 265.531c6.647 0 12.035-3.63 12.035-8.107 0-4.477-5.388-8.107-12.035-8.107s-12.035 3.63-12.035 8.107c0 4.477 5.388 8.107 12.035 8.107zM447.635 282.768c6.646 0 12.035-3.629 12.035-8.106 0-4.478-5.389-8.107-12.035-8.107-6.647 0-12.035 3.629-12.035 8.107 0 4.477 5.388 8.106 12.035 8.106zM463.115 256.144c6.647 0 12.035-3.629 12.035-8.107 0-4.477-5.388-8.106-12.035-8.106s-12.035 3.629-12.035 8.106c0 4.478 5.388 8.107 12.035 8.107zM566.029 354.705c6.647 0 12.035-3.629 12.035-8.107 0-4.477-5.388-8.106-12.035-8.106s-12.035 3.629-12.035 8.106c0 4.478 5.388 8.107 12.035 8.107zM611.236 363.239c0 4.477-5.345 8.106-11.992 8.106-6.647 0-12.078-3.629-12.078-8.106 0-4.478 5.388-8.107 12.035-8.107s12.035 3.63 12.035 8.107zM630.373 476.477c0 4.477-5.346 8.107-11.993 8.107s-12.077-3.63-12.077-8.107c0-4.478 5.388-8.107 12.035-8.107s12.035 3.63 12.035 8.107zM697.31 407.954c0 4.477-5.345 8.106-11.992 8.106-6.647 0-12.078-3.629-12.078-8.106 0-4.478 5.388-8.107 12.035-8.107s12.035 3.63 12.035 8.107zM633.902 388.412c6.647 0 12.035-3.629 12.035-8.107 0-4.477-5.388-8.106-12.035-8.106s-12.035 3.629-12.035 8.106c0 4.478 5.388 8.107 12.035 8.107zM681.957 358.374c6.647 0 12.035-2.693 12.035-6.016 0-3.322-5.388-6.016-12.035-6.016s-12.035 2.694-12.035 6.016c0 3.323 5.388 6.016 12.035 6.016zM715.086 330.897c7.375 0 13.353-3.706 13.353-8.278 0-4.571-5.978-8.277-13.353-8.277s-13.354 3.706-13.354 8.277c0 4.572 5.979 8.278 13.354 8.278zM407.744 460.605c6.647 0 12.035-3.63 12.035-8.107 0-4.477-5.388-8.107-12.035-8.107s-12.035 3.63-12.035 8.107c0 4.477 5.388 8.107 12.035 8.107zM271.361 423.655l21.349-22.699 9.271 5.035zM245.761 353.169l-20.751 4.779 15.053-8.79z",
  fill: "#005054",
  fillRule: "nonzero"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__c)",
  fillRule: "nonzero",
  d: "M428.559 283.56l81.847 3.219-18.969-10.292-26.11-13.943z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#005054",
  fillRule: "nonzero",
  d: "M342.637 232.421l.307 1.858 60.421-34.114-1.106-.683zM344.567 211.346l-59.511-11.352-30.704-17.749 36.402-1.792zM146.503 351.548l49.076-28.161 1.015.674-47.655 27.74-2.351 1.368-.34-.171-50.777-29.355 1.105-.597M496.242 262.544l-52.278 29.867-.482.276-1.164-.676 53.244-29.808zM647.979 350.609l-72.53-13.329 25.24-13.893z"
}), React.createElement("path", {
  fill: "#005054",
  fillRule: "nonzero",
  d: "M487.908 318.097l51.628 30.392 35.914-11.209-51.305-40.457zM375.296 448.402s-39.331 5.888-38.761 5.59c.571-.298 26.173-14.209 26.173-14.209l12.588 8.619zM479.743 504.04l-47.885 14.421-54.598-31.633 28.657-24.261M175.081 134.543l169.512 98.134-1.956 1.622-169.83-98.878z"
}), React.createElement("path", {
  fill: "#005054",
  fillRule: "nonzero",
  d: "M721.295 451.389l-1.786 1.707-231.601-134.999 2.119-1.28zM386.779 259.28l56.731 33.387s1.065-.61 1.213-.688c.148-.079-56.792-33.41-56.792-33.41l-1.152.711zM491.48 550.718l-161.319-93.224-1.837.956 159.584 92.846z"
}), React.createElement("path", {
  d: "M442.192 143.759c17.193 0 31.13-13.983 31.13-31.232 0-17.25-13.937-31.233-31.13-31.233-17.192 0-31.13 13.984-31.13 31.233 0 17.249 13.938 31.232 31.13 31.232z",
  fill: "url(#step-section-estate_svg__e)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M89.549 184.236c3.718-7.594 12.866-10.725 20.434-6.997 7.568 3.729 10.69 12.908 6.974 20.501-3.717 7.593-12.865 10.726-20.434 6.997-7.568-3.729-10.69-12.907-6.974-20.501z",
  fill: "#00A872",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M438.754 81.427l3.694 31.014 30.953-3.336c-1.66-15.68-14.884-27.896-30.953-27.896-1.235 0-2.468.073-3.694.218z",
  fill: "url(#step-section-estate_svg__f)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M61.611 184.749l16.35 20.224s5.206-.762 8.235-8.111l-24.585-12.113z",
  fill: "url(#step-section-estate_svg__g)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M246.962 134.116c16.365 0 29.632-13.811 29.632-30.848S263.327 72.42 246.962 72.42c-16.365 0-29.632 13.81-29.632 30.848 0 17.037 13.267 30.848 29.632 30.848z",
  fill: "url(#step-section-estate_svg__h)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M263.257 76.35c-5.953 3.543-10.172 8.926-12.405 15.068 10.268 4.449 28.096 11.511 28.096 11.511l-4.494-30.402a28.559 28.559 0 00-11.197 3.823z",
  fill: "#00986D",
  fillRule: "nonzero",
  opacity: 0.39
}), React.createElement("path", {
  d: "M695.925 303.163c16.365 0 29.632-13.811 29.632-30.848s-13.267-30.848-29.632-30.848c-16.365 0-29.632 13.811-29.632 30.848s13.267 30.848 29.632 30.848z",
  fill: "url(#step-section-estate_svg__i)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M741.63 245.397c5.954 3.543 10.173 8.926 12.405 15.068-10.268 4.449-28.096 11.511-28.096 11.511l4.494-30.402a28.561 28.561 0 0111.197 3.823z",
  fill: "#00986D",
  fillRule: "nonzero",
  opacity: 0.39
}), React.createElement("path", {
  d: "M556.003 192.997c16.365 0 29.632-13.811 29.632-30.848S572.368 131.3 556.003 131.3c-16.365 0-29.632 13.812-29.632 30.849s13.267 30.848 29.632 30.848z",
  fill: "url(#step-section-estate_svg__i)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M601.708 135.231c5.954 3.543 10.173 8.926 12.406 15.068-10.268 4.448-28.096 11.511-28.096 11.511l4.494-30.402a28.54 28.54 0 0111.196 3.823z",
  fill: "#00986D",
  fillRule: "nonzero",
  opacity: 0.39
}), React.createElement("path", {
  d: "M282.461 304.699c16.934 0 30.661-13.773 30.661-30.763 0-16.99-13.727-30.763-30.661-30.763s-30.662 13.773-30.662 30.763c0 16.99 13.728 30.763 30.662 30.763z",
  fill: "#02846E",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M325.117 343.953c16.934 0 30.662-13.773 30.662-30.763 0-16.99-13.728-30.763-30.662-30.763-16.934 0-30.662 13.773-30.662 30.763 0 16.99 13.728 30.763 30.662 30.763z",
  fill: "url(#step-section-estate_svg__e)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M241.29 244.824c-11.935 4.206-20.491 15.616-20.491 29.027 0 16.99 13.727 30.763 30.662 30.763a30.5 30.5 0 0020.959-8.309c-10.784-17.385-22.588-36.706-31.13-51.481z",
  fill: "url(#step-section-estate_svg__j)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M307.489 256.424a30.705 30.705 0 00-7.288-7.325c-7.083 15.536-15.974 36.367-23.881 55.245a30.498 30.498 0 0023.871-5.035c13.819-9.821 17.086-29.021 7.298-42.885z",
  fill: "#00A872",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M312.224 284.248c-11.935 4.206-20.492 15.616-20.492 29.027 0 16.99 13.728 30.763 30.662 30.763a30.498 30.498 0 0020.959-8.309c-10.784-17.385-22.588-36.705-31.129-51.481z",
  fill: "url(#step-section-estate_svg__k)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M350.571 295.763a30.705 30.705 0 00-7.288-7.325c-7.083 15.536-15.974 36.367-23.881 55.245a30.497 30.497 0 0023.871-5.034c13.819-9.822 17.086-29.022 7.298-42.886z",
  fill: "url(#step-section-estate_svg__l)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M532.533 511.981c16.245-1.987 28.168-13.852 26.631-26.502-1.536-12.65-15.952-21.294-32.196-19.308-16.245 1.987-28.169 13.853-26.632 26.503 1.537 12.65 15.952 21.294 32.197 19.307z",
  fill: "#070634",
  fillRule: "nonzero",
  opacity: 0.29
}), React.createElement("path", {
  d: "M546.356 447.719c16.366 0 29.632-13.811 29.632-30.848s-13.266-30.848-29.632-30.848c-16.365 0-29.631 13.811-29.631 30.848s13.266 30.848 29.631 30.848z",
  fill: "#00645F",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M531.652 389.953c-5.954 3.543-10.172 8.926-12.406 15.068 10.269 4.449 28.097 11.511 28.097 11.511l-4.491-30.402a28.559 28.559 0 00-11.2 3.823z",
  fill: "#00986D",
  fillRule: "nonzero",
  opacity: 0.39
}), React.createElement("path", {
  d: "M233.258 166.885c12.753 0 23.092-10.373 23.092-23.169 0-12.795-10.339-23.168-23.092-23.168-12.753 0-23.092 10.373-23.092 23.168 0 12.796 10.339 23.169 23.092 23.169z",
  fill: "url(#step-section-estate_svg__i)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M257.939 165.949l6.316-22.235-18.858-13.355a23.112 23.112 0 00-4.192 13.312c0 10.582 7.072 19.507 16.734 22.278z",
  fill: "#00986D",
  fillRule: "nonzero",
  opacity: 0.92
}), React.createElement("path", {
  d: "M78.522 278.758c16.366 0 29.632-13.812 29.632-30.849s-13.266-30.848-29.632-30.848c-16.365 0-29.631 13.811-29.631 30.848s13.266 30.849 29.631 30.849z",
  fill: "url(#step-section-estate_svg__i)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M94.818 220.991c-5.954 3.544-10.173 8.926-12.406 15.069 10.269 4.448 28.096 11.51 28.096 11.51l-4.492-30.402a28.568 28.568 0 00-11.198 3.823z",
  fill: "#00986D",
  fillRule: "nonzero",
  opacity: 0.39
}), React.createElement("path", {
  d: "M167.327 237.2c16.365 0 29.632-13.811 29.632-30.848s-13.267-30.849-29.632-30.849c-16.365 0-29.632 13.812-29.632 30.849s13.267 30.848 29.632 30.848z",
  fill: "#00645F",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M152.62 179.434c-5.954 3.543-10.172 8.926-12.405 15.068 10.268 4.449 28.096 11.511 28.096 11.511l-4.494-30.402a28.545 28.545 0 00-11.197 3.823z",
  fill: "#00986D",
  fillRule: "nonzero",
  opacity: 0.39
}), React.createElement("path", {
  d: "M72.803 284.816c12.753 0 23.092-10.372 23.092-23.168 0-12.795-10.339-23.168-23.092-23.168-12.753 0-23.092 10.373-23.092 23.168 0 12.796 10.339 23.168 23.092 23.168z",
  fill: "#00A872",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M66.483 284.052l6.316-22.236-18.858-13.355a23.118 23.118 0 00-4.191 13.313c0 10.582 7.072 19.507 16.733 22.278zM266.248 166.658c5.103-.524 9.611-2.826 13.02-6.259-5.529-6.199-15.324-16.519-15.324-16.519l-6.413 21.851a21.16 21.16 0 008.717.927z",
  fill: "#00986D",
  fillRule: "nonzero",
  opacity: 0.39
}), React.createElement("path", {
  fill: "#FFC47B",
  fillRule: "nonzero",
  d: "M734.588 353.772l-.736.427v-19.521l.736-.427zM741.401 349.872l-.737.426v-18.82l.737-.427zM748.215 345.952l-.736.427v-18.82l.736-.426zM713.964 365.822l-.761.44v-19.426l.761-.441zM720.822 361.877l-.736.426v-18.82l.736-.427zM727.705 357.918l-.736.427v-18.821l.736-.427zM693.289 377.909l-.736.427v-19.521l.736-.427zM700.174 373.95l-.736.427v-18.82l.736-.427zM707.057 369.991l-.737.427v-18.82l.737-.427zM672.641 389.954l-.737.427v-18.82l.737-.427zM666.307 393.652l-.737.426v-18.622l.737-.427zM679.524 386.024l-.737.426v-18.82l.737-.427zM686.408 382.065l-.736.427v-18.821l.736-.427zM754.439 342.459l-.72.322 1.436-20.439.722-.322z"
}), React.createElement("path", {
  fill: "#FFC47B",
  fillRule: "nonzero",
  d: "M659.31 397.663l-.982-18.498 105.651-62.627-.515 20.794-1.105.64.368-19.428-103.301 61.176.768 17.431z"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__m)",
  fillRule: "nonzero",
  d: "M292.158 45.625l67.788 36.608-18.967-30.123-30.619-17.664z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__n)",
  fillRule: "nonzero",
  d: "M420.42 228.159l47.46-24.75v-49.584l-47.46 27.146z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  d: "M459.414 190.351v11.691l21.263-9.984.086-11.605z"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__o)",
  fillRule: "nonzero",
  d: "M259.752 180.538l55.54 32 .085-98.817-55.625-31.659z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__m)",
  fillRule: "nonzero",
  d: "M430.626 66.958l-60.552 33.893.419 98.129 60.133-31.242z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__p)",
  fillRule: "nonzero",
  d: "M259.752 180.453l-4.082-9.558.51-102.998 3.513 5.874z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#BA3543",
  fillRule: "nonzero",
  d: "M401.237 101.007l-30.024-48.385 60.136-35.012 30.276 49.69z"
}), React.createElement("path", {
  fill: "#FB5347",
  fillRule: "nonzero",
  d: "M290.752 81.977l55.625 31.659 2.296-27.648-39.549-22.955z"
}), React.createElement("path", {
  fill: "#A02436",
  fillRule: "nonzero",
  d: "M400.896 100.836l-54.519 12.8 2.296-27.648 41.421-4.267zM291.347 81.21l11.568-11.777 20.242-23.808-35.977 22.272z"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__q)",
  fillRule: "nonzero",
  d: "M370.238 198.885l50.102 29.014v-47.182l-29.434-49.758-20.668 21.163z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__r)",
  fillRule: "nonzero",
  d: "M370.234 198.81l-54.865 13.48.009-98.654 54.69-12.971z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M290.753 180.453l55.625 31.829 54.859-13.312v-13.227l-54.859 13.237-55.625-32.041-3.998-9.271-.425 12.289z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M290.779 127.523l55.6 32.023-.041 2.624-55.559-32.285zM290.779 80.846l55.6 32.278-.041 2.368-55.559-32.285z"
}), React.createElement("path", {
  fill: "#BA3543",
  fillRule: "nonzero",
  d: "M422.021 131.164l29.312 49.886 47.545-27.392-29.992-49.46z"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M346.377 159.546l54.774-12.288.086 2.475-54.86 12.458z"
}), React.createElement("path", {
  d: "M422.268 161.452l6.85 3.968v-11.15c0-.676-.418-1.689-1.07-2.345a11.78 11.78 0 00-2.371-1.814 7.538 7.538 0 00-2.297-.837c-.68-.116-1.116.42-1.116 1.119l.004 11.059z",
  fill: "#F7E7DD",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M428.03 157.988v-3.233c0-.557-.291-1.544-.744-2.036a7.293 7.293 0 00-1.65-1.318c-.48-.279-1.08-.5-1.594-.519-.539-.02-.776.612-.776 1.188v3.157l4.764 2.761z",
  fill: "#A4DEE4",
  fillRule: "nonzero"
}), React.createElement("path", {
  fill: "#13597A",
  fillRule: "nonzero",
  d: "M423.295 161.072l4.765 2.76v-5.449l-4.765-2.761z"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  d: "M425.545 162.501l.298.172v-11.557l-.298-.173z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M427.259 123.048l-12.655 7.331v-25.915l12.655-7.33z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M425.479 122.205l-9.182 5.319v-10.476l9.182-5.319z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M427.602 123.622l-13.524 7.834v-.773l13.524-7.833z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M416.27 127.54v-10.476l9.213-5.338v10.477l-1.443-7.766-5.995 3.473z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M421.042 106.359l-3.431 1.987v-.11l3.431-1.987zM422.959 106.461l-3.432 1.988v-.11l3.432-1.988zM424.777 106.622l-3.431 1.987v-.11l3.431-1.988zM421.079 110.86l-3.431 1.988v-.11l3.431-1.989zM453.286 108.883l-12.655 7.331V90.299l12.655-7.331z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M451.505 108.04l-9.183 5.319v-10.477l9.183-5.319z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M453.629 109.456l-13.524 7.834v-.772l13.524-7.834z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M442.295 113.375v-10.477l9.214-5.337v10.476l-1.444-7.765-5.994 3.472z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M447.068 92.193l-3.431 1.988v-.11l3.431-1.988zM448.987 92.296l-3.432 1.987v-.11l3.432-1.987zM450.802 92.456l-3.431 1.987v-.11l3.431-1.987zM447.107 96.695l-3.431 1.987v-.11l3.431-1.988z"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  d: "M406.171 169.445l39.38 21.504.004 33.6-39.639-22.933z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M358.031 120.548l33.426-6.315v25.345l-33.682 6.997z"
}), React.createElement("path", {
  fill: "#13597A",
  fillRule: "nonzero",
  d: "M460.436 190.949v9.216l19.392-9.216v-8.704z"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__m)",
  fillRule: "nonzero",
  d: "M374.916 201.616l1.106-.342.263-31.221-1.114-.608z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#070634",
  fillRule: "nonzero",
  d: "M405.916 201.616l39.635 22.954v-1.109l-38.274-22.187z"
}), React.createElement("path", {
  fill: "#E6CACD",
  fillRule: "nonzero",
  opacity: 0.35,
  d: "M407.275 201.274l1.787-26.027 36.488 15.702-38.275-20.907z"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__m)",
  fillRule: "nonzero",
  d: "M369.896 153.829l24.581-16.811-3.487-6.059z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#A02436",
  fillRule: "nonzero",
  d: "M401.098 151.843l.055 1.73 20.87-22.409z"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__s)",
  fillRule: "nonzero",
  d: "M448.827 190.949h-1.616v-7.979l1.616-.725z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__t)",
  fillRule: "nonzero",
  d: "M429.436 198.98l17.776-8.484 1.616.453-19.392 9.216z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  d: "M470.045 185.999v10.496l1.021-.512v-10.496z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M298.748 121.828l36.573 21.248.085-26.453-36.403-20.395z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M317.801 108.516v22.699l7.484 4.523v-23.126l-7.173-3.925zM326.645 113.636v22.699l7.484 4.523v-23.126zM300.023 98.447v22.698l7.485 4.523v-23.125zM308.955 103.311v22.698l7.485 4.523v-23.125z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M297.557 121.146l39.379 22.954v1.622l-39.379-23.126z"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__u)",
  fillRule: "nonzero",
  d: "M266.557 122.596l38.184 23.954 1.317-.781z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__v)",
  fillRule: "nonzero",
  d: "M269.447 98.679l.003 16.152 7.059 4.821v-17.109z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__w)",
  fillRule: "nonzero",
  d: "M269.449 98.703l7.06 5.966v-2.126z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M307.509 116.51v.411l-5.529-3.285zM305.892 111.22v.411l-5.529-3.286zM307.509 108.489v.411l-5.529-3.285z"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__m)",
  fillRule: "nonzero",
  d: "M278.354 103.529l.026 18.214 7.059 4.749v-18.741z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M297.896 164.58l36.574 21.249.085-26.454-36.403-20.395z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M316.949 151.269v22.698l7.485 4.523v-23.125zM325.795 156.388v22.699l7.485 4.523v-23.126zM299.174 141.199v22.699l7.485 4.523v-23.126zM308.104 146.063v22.699l7.484 4.523v-23.126z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M296.707 163.898l39.38 22.955v1.621l-39.38-23.125z"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__x)",
  fillRule: "nonzero",
  d: "M305.087 188.474l-39.38-21.626-.016-1.536z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  d: "M299.596 141.431l.002 16.152 7.06 4.182v-16.47z"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M306.657 159.262v.412l-5.528-3.286z"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  d: "M308.502 146.281l.026 12.497 7.06 3.669v-12.288z"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__y)",
  fillRule: "nonzero",
  d: "M278.379 103.567l7.059 3.84v2.56z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M317.246 151.598l4.976 6.156 1.969 20.59.242-22.979zM325.795 156.388l4.168 7.424.425 18.051 2.892 1.747v-23.126z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M346.377 115.513l54.855-12.794-.166-2.054-54.689 12.459z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M356.414 148.196v-1.621l36.318-7.595v1.28z"
}), React.createElement("path", {
  fill: "#EAD7CC",
  fillRule: "nonzero",
  d: "M299.598 141.455l7.059 6.741v-2.901zM299.598 156.388s4.337 2.304 4.252 2.134c-.085-.171-4.252-1.811-4.252-1.811v-.323zM306.658 158.031l-5.273-2.923 5.273 3.423zM301.129 151.61l4.678 2.304-2.297-.768zM309.125 156.388l5.443 1.622-3.657-.768zM308.529 146.319l7.06 6.051v-2.211z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M401.237 102.713l60.388-33.243v-2.512l-60.559 33.707z"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__z)",
  fillRule: "nonzero",
  d: "M370.238 112.058l60.388-42.625-60.388 33.28z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__A)",
  fillRule: "nonzero",
  d: "M315.369 122.85l54.869-10.835v-9.302l-54.86 12.801z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__B)",
  fillRule: "nonzero",
  d: "M315.377 122.852l-55.625-39.68 55.625 32.342z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M287.18 67.897l4.173 13.282-.601 1.822-3.912-13.739z"
}), React.createElement("path", {
  fill: "#FB5347",
  fillRule: "nonzero",
  d: "M371.069 52.617l-30.811-17.848L400.916 0l30.812 17.848z"
}), React.createElement("path", {
  d: "M344.189 52.48l6.851 3.969V45.298c0-.676-.419-1.689-1.07-2.344a11.778 11.778 0 00-2.372-1.814 7.52 7.52 0 00-2.292-.837c-.68-.117-1.117.42-1.117 1.118v11.06z",
  fill: "#F7E7DD",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M349.95 49.016v-3.233c0-.557-.291-1.543-.744-2.036a7.287 7.287 0 00-1.65-1.318c-.481-.278-1.08-.5-1.594-.519-.539-.02-.776.613-.776 1.188v3.157l4.764 2.76z",
  fill: "#A4DEE4",
  fillRule: "nonzero"
}), React.createElement("path", {
  fill: "#13597A",
  fillRule: "nonzero",
  d: "M345.217 52.1l4.764 2.76v-5.449l-4.764-2.76z"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  d: "M347.465 53.53l.298.172V42.144l-.298-.172zM356.777 59.82l6.851 3.967v-11.15c0-.676-.419-1.69-1.07-2.345a11.778 11.778 0 00-2.372-1.814 7.52 7.52 0 00-2.292-.837c-.68-.116-1.117.42-1.117 1.119v11.06z"
}), React.createElement("path", {
  d: "M362.538 56.355v-3.233c0-.557-.291-1.543-.744-2.036a7.309 7.309 0 00-1.65-1.318c-.481-.278-1.08-.5-1.594-.519-.539-.02-.777.613-.777 1.188v3.157l4.765 2.76z",
  fill: "#A4DEE4",
  fillRule: "nonzero"
}), React.createElement("path", {
  fill: "#13597A",
  fillRule: "nonzero",
  d: "M357.805 59.44l4.764 2.76v-5.45l-4.764-2.76z"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  d: "M360.053 60.868l.297.172V49.483l-.297-.173z"
}), React.createElement("path", {
  fill: "#BA3543",
  fillRule: "nonzero",
  d: "M302.916 69.433l44.738 23.979 44.313-11.435-68.808-36.352z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M366.11 143.674l-7.059 1.365v-23.552l7.059-1.195zM374.36 141.967l-7.059 1.365v-23.381l7.059-1.366zM382.356 140.26l-7.059 1.366v-23.297l7.059-1.45zM390.436 138.468l-7.059 1.622v-23.211l7.059-1.366z"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__m)",
  fillRule: "nonzero",
  d: "M287.225 123.962v-15.275l7.059 4.096v15.445zM295.975 113.817l.01 17.056 7.144 4.865v-18.006z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__C)",
  fillRule: "nonzero",
  d: "M294.284 112.612v3.594l-7.059-7.519z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__D)",
  fillRule: "nonzero",
  d: "M304.321 143.076l-32.813-19.045 32.899 18.337-.086.367z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M314.909 113.551l1.616 1.237-5.529-3.285zM312.526 107.919l2.381 1.578-5.528-3.285zM323.499 124.303l1.361.896-3.913-2.005zM324.944 119.951l-1.19-.384-4.338-2.432z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M359.051 122.127l5.273 1.067 1.786 20.394v-23.296l-7.059 1.195zM367.301 119.951l7.059-1.366v19.276l-1.361-17.569zM375.297 118.244l7.059-1.365v19.275l-1.361-17.569zM383.377 116.964l7.059-1.365v19.275l-1.36-17.569z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M290.778 166.948v2.361l55.559 32.285.041-2.624-55.6-32.022-4.108-9.45-.012 2.975 4.095 8.801"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M346.377 201.616l54.855-13.142.005-2.645-54.86 13.141z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M299.174 108.345l35.382 20.31v1.195l-34.957-20.31M298.832 151.439l35.382 20.31v1.194l-34.957-20.309M359.051 131.94l31.895-6.016v-1.109l-31.895 6.144z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M357.521 163.813l33.426-6.145v25.174l-33.681 6.997z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M355.904 191.461v-1.622l36.318-7.594v1.28z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M365.6 186.938l-7.059 1.366v-23.638l7.059-1.109zM373.85 185.231l-7.059 1.366v-23.382l7.059-1.365z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M358.541 165.391l5.273 1.067 1.786 20.395v-23.296l-7.059 1.109zM366.791 163.215l7.059-1.365v19.275l-1.36-17.568z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M382.015 183.696l-7.06 1.365v-23.382l7.06-1.194zM390.095 181.989l-7.06 1.365v-23.125l7.06-1.366z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M374.955 162.149l5.273 1.066 1.787 20.395v-23.125l-7.06 1.194zM383.035 160.229l7.06-1.366v19.276l-1.361-17.569z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M358.371 175.205l31.895-6.016v-1.11l-31.895 6.144z"
}), React.createElement("path", {
  fill: "#FB5347",
  fillRule: "nonzero",
  d: "M323.158 45.625l1.135.6 17.416-10.614-1.455-.824z"
}), React.createElement("path", {
  fill: "#5A809E",
  fillRule: "nonzero",
  d: "M416.207 105.615l9.186-5.291.085 9.984-9.271 5.803zM442.318 91.364l9.186-5.29.085 9.983-9.271 5.803z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M416.27 115.96l2.221-1.27.886-8.911 4.552-2.637 1.55 6.025.004-9.02-9.213 5.338z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M420.377 113.692l.666-.386v-10.587l-.666.386z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M442.295 101.795l2.222-1.27.886-8.911 4.552-2.637 1.55 6.025.004-9.02-9.214 5.338z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M446.402 99.527l.666-.387V88.554l-.666.385z"
}), React.createElement("path", {
  fill: "#E08663",
  fillRule: "nonzero",
  d: "M647.973 350.618v-85.985l29.179-55.423 37.095 28.718-.267 75.902z"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M647.979 332.604l66.268-36.591-.267 17.817-66.001 36.779z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M709.891 270.079l-12.655 7.331v-25.915l5.771-7.042 6.884-.289z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M708.112 269.236l-9.182 5.319v-10.477l9.182-5.318zM708.112 257.631l-9.182 5.318v-10.476l9.182-5.319z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M710.234 270.653l-13.523 7.833v-.772l13.523-7.834z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M698.925 262.971l2.199-1.336.886-8.91 4.552-2.637 1.55 6.025.004-9.02-9.214 5.337z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M698.902 274.571v-10.476l9.214-5.338v10.477l-1.443-7.766-5.995 3.472z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M703.01 260.723l.666-.386V249.75l-.666.386zM709.722 304.725l-12.656 7.331v-25.915l5.771-7.042 6.885-.289z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M707.942 303.882l-9.182 5.319v-10.477l9.182-5.319zM707.942 292.276l-9.182 5.319v-10.476l9.182-5.319z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M698.755 297.616l2.199-1.335.886-8.911 4.552-2.636 1.55 6.024.004-9.02-9.214 5.338z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M698.732 309.217V298.74l9.214-5.337v10.476l-1.443-7.765-5.995 3.472z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M702.84 295.369l.666-.387v-10.586l-.666.385z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M710.065 305.298l-13.524 7.834v-.772l13.524-7.834z"
}), React.createElement("path", {
  fill: "#FFC47B",
  fillRule: "nonzero",
  d: "M491.904 260.073l156.074 90.536v-88.235l-156.074-90.34z"
}), React.createElement("path", {
  fill: "#E08663",
  fillRule: "nonzero",
  d: "M573.557 338.321l27.132-14.934v-88.23L574.067 250l-.51 87.894"
}), React.createElement("path", {
  fill: "#014163",
  fillRule: "nonzero",
  d: "M491.904 172.005l155.648 91.307 29.219-55.359-157.309-90.989-26.833 53.593z"
}), React.createElement("path", {
  fill: "#222350",
  fillRule: "nonzero",
  d: "M492.84 172.602l155.138 92.161 29.218-55.359z"
}), React.createElement("path", {
  fill: "#014163",
  fillRule: "nonzero",
  d: "M541.83 197.69l32.235 53.505 26.707-14.934-30.789-53.419-28.132 14.848 32.214 53.505"
}), React.createElement("path", {
  fill: "#222350",
  fillRule: "nonzero",
  d: "M569.984 182.757l4.083 68.352 27.047-14.933z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M594.05 274.09l-12.655 7.331v-25.915l5.77-7.042 6.885-.289z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M592.268 273.247l-9.182 5.319v-10.477l9.182-5.319zM592.268 261.641l-9.182 5.319v-10.476l9.182-5.319z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M594.393 274.663l-13.524 7.834v-.772l13.524-7.834z"
}), React.createElement("path", {
  fill: "#FB5347",
  fillRule: "nonzero",
  d: "M583.082 266.982l2.198-1.336.886-8.91 4.553-2.637 1.549 6.024.004-9.019-9.213 5.337z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M583.059 278.582v-10.477l9.213-5.337v10.476l-1.443-7.765-5.994 3.472z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M587.166 264.734l.666-.387v-10.586l-.666.385z"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  d: "M608.428 277.478l28.918 15.872v-26.198l-14.459-11.008-14.459-5.461z"
}), React.createElement("path", {
  fill: "#E08663",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M600.773 246.928l47.204 17.835-47.289-28.075z"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  d: "M495.562 261.321v.882-32.939l24.241 13.227-.425 33.536-23.816-13.824"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M600.773 305.485l47.198 26.525.006 18.599-47.289-27.222z"
}), React.createElement("path", {
  fill: "#E08663",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M608.428 316.817v2.73l28.493 14.251.425-1.195z"
}), React.createElement("path", {
  fill: "#CE795F",
  fillRule: "nonzero",
  d: "M647.979 264.592l30.108-46.507 36.148 19.883-36.998-28.758z"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M600.774 306.961l-27.129 15.633-.088 15.898 27.132-15.104z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M610.129 253.755v22.101l5.528 3.243v-21.846zM616.424 257.68l.085 21.675 5.358 3.157v-21.845zM622.717 260.923v22.101l5.783 3.243v-21.845zM629.352 264.592v22.102l5.868 3.157v-21.845z"
}), React.createElement("path", {
  d: "M610.654 254.09l.751 20.742s4.252 2.186 4.252 2.39v1.877l-5.528-3.243v-22.101l.525.335z",
  fill: "#01375C",
  fillRule: "nonzero"
}), React.createElement("path", {
  fill: "#F6E7DB",
  fillRule: "nonzero",
  d: "M573.418 250.176l27.441-15.877.085 2.304-26.962 15.445z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M666.259 327.168l-12.655 7.331v-25.915l5.77-7.042 6.885-.289z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M664.479 326.325l-9.182 5.318v-10.476l9.182-5.319zM664.479 314.719l-9.182 5.319v-10.476l9.182-5.319z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M666.604 327.741l-13.524 7.834v-.772l13.524-7.834z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M655.292 320.059l2.199-1.335.886-8.911 4.552-2.637 1.55 6.025.004-9.02-9.213 5.338z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M655.27 331.66v-10.477l9.213-5.337v10.476l-1.443-7.765-5.995 3.472z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M659.377 317.812l.666-.387v-10.586l-.666.385z"
}), React.createElement("path", {
  fill: "#CE795F",
  fillRule: "nonzero",
  d: "M671.793 289.851v18.262l17.266-9.729.679-1.367-2.465 1.367zM652.91 297.104l-.765 1.536 14.289-9.386zM581.125 282.512l-.766 1.536 14.289-9.386z"
}), React.createElement("path", {
  fill: "#F6E7DB",
  fillRule: "nonzero",
  d: "M600.773 234.299l47.204 28.075v2.389l-47.289-28.075z"
}), React.createElement("path", {
  fill: "#E08663",
  fillRule: "nonzero",
  d: "M653.08 335.59l5.699-1.792 7.825-6.058z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M594.899 313.6l-12.655 7.331v-25.915l5.771-7.042 6.884-.289z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M593.12 312.757l-9.182 5.318v-10.476l9.182-5.319zM593.12 301.151l-9.182 5.319v-10.477l9.182-5.318z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M595.242 314.173l-13.523 7.834v-.772l13.523-7.834z"
}), React.createElement("path", {
  fill: "#FB5347",
  fillRule: "nonzero",
  d: "M583.933 306.491l2.199-1.335.886-8.911 4.552-2.637 1.55 6.025.004-9.02-9.214 5.338z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M583.91 318.091v-10.476l9.214-5.338v10.477l-1.443-7.766-5.995 3.473z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M588.018 304.244l.666-.387v-10.586l-.666.385z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M616.502 277.95l.005 1.405 5.358 3.157v-1.583zM622.717 281.421v1.603l5.783 3.243v-2.237l-5.613-2.627M629.352 284.219l5.868 2.56v3.072l-5.868-3.072z"
}), React.createElement("path", {
  fill: "#E08663",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M608.428 277.478v5.034l28.918 10.838z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M607.578 276.539v.939l30.619 16.725v-.939l-30.619-16.981"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  d: "M608.428 316.134l28.918 15.872v-26.197L622.887 294.8l-14.459-5.461z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M610.129 292.411v22.102l5.528 3.242V295.91zM616.424 296.336l.085 21.675 5.358 3.158v-21.846zM622.717 299.579v22.102l5.783 3.242v-21.845zM629.352 303.249v22.101l5.868 3.157v-21.845z"
}), React.createElement("path", {
  d: "M610.654 292.747l.751 20.742s4.252 2.185 4.252 2.389v1.877l-5.528-3.242v-21.766h.525z",
  fill: "#222350",
  fillRule: "nonzero"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M607.578 315.195v.939l30.619 16.726v-.939l-30.619-16.982"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  d: "M499.389 215.013l28.918 15.872v-26.197l-14.459-11.009-14.459-5.461z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M501.09 191.29v22.102l5.528 3.242v-21.845zM507.385 195.216l.085 21.674 5.358 3.158v-21.846zM513.678 198.458v22.102l5.783 3.242v-21.845zM520.312 202.128v22.101l5.869 3.158v-21.846z"
}), React.createElement("path", {
  d: "M501.615 191.625l.751 20.743s4.252 2.185 4.252 2.389v1.877l-5.528-3.242v-21.767h.525z",
  fill: "#01375C",
  fillRule: "nonzero"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M498.539 214.074v.939l30.619 16.726v-.939l-30.619-16.982"
}), React.createElement("path", {
  fill: "#CE795F",
  fillRule: "nonzero",
  d: "M659.204 262.8l-5.784 7.254.013 25.959-1.288 2.628v-28.587zM587.165 248.464l-5.784 7.254.013 25.959-1.289 2.627v-28.586zM582.06 321.595l-.765 1.536 14.289-9.386zM588.1 287.547l-5.783 7.254.013 25.959-1.289 2.627v-28.586zM702.667 278.843l-5.784 7.253.17 25.857-.51.512-.936-26.369z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M666.089 288.682l-12.655 7.331v-25.915l5.77-7.042 6.885-.289z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M664.309 287.839l-9.182 5.319v-10.477l9.182-5.318zM664.309 276.234l-9.182 5.318v-10.476l9.182-5.319z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M655.123 281.574l2.198-1.336.886-8.91 4.553-2.637 1.549 6.024.004-9.019-9.213 5.337z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M655.1 293.174v-10.476l9.213-5.338v10.476l-1.443-7.765-5.994 3.472z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M659.207 279.326l.666-.387v-10.586l-.666.385z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M666.434 289.255l-13.524 7.834v-.772l13.524-7.834z"
}), React.createElement("path", {
  fill: "#FFC47B",
  fillRule: "nonzero",
  d: "M671.793 289.814l15.48 8.57v-33.792l-15.48-9.113z"
}), React.createElement("path", {
  fill: "#E08663",
  fillRule: "nonzero",
  d: "M705.73 257.595v30.549l-18.457 10.241v-33.793l11.908-19.029z"
}), React.createElement("path", {
  fill: "#222350",
  fillRule: "nonzero",
  d: "M671.793 255.461L682.68 237.2l16.5 8.363-11.907 19.029z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M702.917 282.623l-12.655 7.331v-25.915l5.771-7.041 6.884-.29z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M701.137 281.78l-9.182 5.319v-10.476l9.182-5.319zM701.137 270.175l-9.182 5.319v-10.477l9.182-5.319z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M703.262 283.197l-13.524 7.834v-.773l13.524-7.833z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M691.951 275.515l2.198-1.336.887-8.91 4.552-2.637 1.549 6.025.005-9.02-9.214 5.337z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M691.928 287.115v-10.476l9.214-5.338v10.477l-1.444-7.766-5.994 3.473z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M696.035 273.267l.666-.386v-10.587l-.666.386z"
}), React.createElement("path", {
  fill: "#E08663",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M671.793 261.321l15.48 3.271-15.48-9.131z"
}), React.createElement("path", {
  fill: "#FFC47B",
  fillRule: "nonzero",
  d: "M518.951 308.198l54.593 30.635.437-87.724-32.15-53.248-21.604 20.395z"
}), React.createElement("path", {
  fill: "#F6E7DB",
  fillRule: "nonzero",
  d: "M524.311 320.145l22.964 13.141v-4.096l-22.964-12.885zM526.605 314.939l22.965 13.142v-4.096l-22.965-12.886zM529.414 309.734l22.965 13.142v-4.097l-22.965-12.885z"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M518.951 293.179l16.16 7.851-.17 16.128-15.99-8.96zM551.528 311.782l-.34 14.507 22.113 12.459.256-16.129z"
}), React.createElement("path", {
  d: "M524.311 316.305s22.624 13.056 22.964 12.885c.34-.17 2.296-1.109 2.296-1.109l-22.964-13.142-2.296 1.366zM526.605 311.099l22.965 12.971c.34-.171 2.807-1.195 2.807-1.195l-23.135-13.226-2.296 1.365M529.414 305.809s22.624 13.056 22.965 12.885c.34-.171 2.296-1.109 2.296-1.109l-22.964-13.142-2.297 1.366z",
  fill: "#FFC47B",
  fillRule: "nonzero"
}), React.createElement("path", {
  fill: "#E08663",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M520.227 218.256l19.307-10.667 34.446 44.459-32.15-54.187z"
}), React.createElement("path", {
  fill: "#E08663",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M491.904 172.005v9.045l47.545 19.115z"
}), React.createElement("path", {
  fill: "#F6E7DB",
  fillRule: "nonzero",
  d: "M543.627 196.754l32.365 54.142-2.011 1.152-32.831-53.76z"
}), React.createElement("path", {
  fill: "#CE795F",
  fillRule: "nonzero",
  d: "M574.021 257.68l26.666-20.992-26.707 15.36z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M645.83 263.487l29.689-56.163 1.718-.93 38.359 30.294-1.361 1.28-36.998-28.758-29.258 55.553zM697.649 244.88l-11.971 18.773 1.594.939 11.908-19.029z"
}), React.createElement("path", {
  fill: "#CE795F",
  fillRule: "nonzero",
  d: "M687.273 264.592l10.63-13.909 7.827 6.997-6.549-12.117z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M697.65 244.88l-.425.683 8.505 12.117.595-.939-7.144-11.178z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M507.469 215.184v1.706l5.358 3.158v-1.91zM513.848 218.682l-.17 1.878 5.783 3.242v-2.103z"
}), React.createElement("path", {
  fill: "#F6E7DB",
  fillRule: "nonzero",
  d: "M520.273 218.479l-2.511.033 20.923-18.774 4.933-2.987z"
}), React.createElement("path", {
  fill: "#F6E7DB",
  fillRule: "nonzero",
  d: "M491.734 172.175l46.764 27.731 1.972-1.277-47.545-28.587zM535.367 306.32l16.586 9.473.109-36.038-16.586-7.424z"
}), React.createElement("path", {
  fill: "#E08663",
  fillRule: "nonzero",
  d: "M536.557 306.918l14.195 8.107.094-30.845-14.196-6.354z"
}), React.createElement("path", {
  fill: "#222350",
  fillRule: "nonzero",
  d: "M616.502 316.254l.005 1.843 5.358 3.072v-1.809l-5.358-3.141"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  d: "M530.604 258.79l28.918 15.872v-26.198l-14.459-11.008-14.459-5.461z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M532.305 235.067v22.101l5.528 3.243V238.565zM538.6 238.992l.085 21.675 5.358 3.157v-21.845zM544.893 242.235v22.101l5.783 3.243v-21.846zM551.527 245.904v22.102l5.869 3.157v-21.846z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M551.527 265.531l5.869 2.56v3.072l-5.869-3.072z"
}), React.createElement("path", {
  fill: "#E08663",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M530.604 258.79v5.034l28.918 10.838z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M529.754 257.851v.938l30.619 16.726v-.939l-30.619-16.981"
}), React.createElement("path", {
  fill: "#222350",
  fillRule: "nonzero",
  d: "M622.717 320.038v1.643l5.783 3.242v-1.792zM629.352 323.556l5.868 3.193v1.759l-5.868-3.158v-2.038"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  d: "M600.688 322.007v1.381l47.289 27.221 66.002-36.864v-1.707l-66.008 36.683z"
}), React.createElement("path", {
  fill: "#E08663",
  fillRule: "nonzero",
  d: "M547.273 333.286l7.825-4.608v-11.264l-2.721 1.28-.085 4.181-2.722 1.11v4.096l-2.297 1.109z"
}), React.createElement("path", {
  fill: "#E6CACD",
  fillRule: "nonzero",
  opacity: 0.35,
  d: "M495.562 229.264l24.186 22.784.055-9.557z"
}), React.createElement("path", {
  fill: "#E08663",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M498.539 216.037l21.263 13.227.305-2.47z"
}), React.createElement("path", {
  fill: "#6A8EAD",
  fillRule: "nonzero",
  d: "M610.724 254.95l4.933 4.096v-1.792l-5.018-3.158M616.424 259.131l5.443 3.328v-1.792l-5.443-2.987M622.717 262.715l5.783 3.669v-1.962l-5.783-3.499M629.352 266.64l5.868 3.499v-2.133l-5.868-3.414"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__c)",
  fillRule: "nonzero",
  d: "M464.562 258.801l23.901 14.325-.029-1.133-23.872-14.281v1.675M464.562 253.425l23.901 14.325-.029-1.133-23.872-14.281v1.675M464.562 248.123l24.071 14.421-.028-1.132-23.872-14.282-.171-.117M464.562 243.259l24.071 14.421-.028-1.132-23.872-14.282-.171-.117M464.562 237.883l24.071 14.421-.028-1.132-23.872-14.282-.171-.117M464.562 232.592l24.241 14.507-.028-1.133-23.872-14.281-.341-.203",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#E08663",
  fillRule: "nonzero",
  d: "M495.562 229.264l.313.294.028 32.816-.341-.171z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M544.893 264.336l5.783 3.243v-2.16l-5.783-2.96z"
}), React.createElement("path", {
  d: "M551.527 245.904l5.869 3.413v16.214s-5.869-15.446-5.869-19.627z",
  fill: "#FB5347",
  fillRule: "nonzero"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M538.6 259.045l5.443 2.832v1.947l-5.443-3.413zM533.58 255.718l4.253 2.816v1.877l-5.528-3.243v-22.101z"
}), React.createElement("path", {
  d: "M532.621 235.266s1.045 13.027 5.213 14.329c.17.054 0-11.03 0-11.03l-5.213-3.299zM538.6 238.992v10.581s5.273.342 5.443-7.594c0-.171-5.443-2.987-5.443-2.987z",
  fill: "#FB5347",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M548.379 300.518c.705 0 1.276-.726 1.276-1.622 0-.895-.571-1.621-1.276-1.621-.704 0-1.275.726-1.275 1.621 0 .896.571 1.622 1.275 1.622z",
  fill: "#F6E7DB",
  fillRule: "nonzero"
}), React.createElement("path", {
  fill: "#BA3543",
  fillRule: "nonzero",
  d: "M235.213 294.8v16.129l10.499-5.59.048 48.001 42.867-25.686v-63.915l-14.204-8.278z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M275.221 320.53l-13.524 7.833v-.771l13.524-7.834z"
}), React.createElement("path", {
  fill: "#F6EBDF",
  fillRule: "nonzero",
  d: "M274.804 320.085l-12.656 7.331v-25.915l12.656-7.331z"
}), React.createElement("path", {
  fill: "#81D2DB",
  fillRule: "nonzero",
  d: "M273.024 307.662l-9.182 5.319v-10.477l9.182-5.318z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M273.098 319.797l-9.182 5.319v-11.074l9.182-5.32z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M263.814 312.997l2.223-1.271.886-8.91 4.551-2.637 1.551 6.025.003-9.02-9.214 5.337z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M263.837 325.161l-.023-11.062 9.214-5.336v10.087l-1.442-7.446-3.992 2.297-1.031 9.882z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M268.588 303.395l-3.432 1.988v-.11l3.432-1.989zM270.505 303.497l-3.431 1.988v-.111l3.431-1.987zM272.322 303.658l-3.431 1.988v-.11l3.431-1.988z"
}), React.createElement("path", {
  fill: "#FB5347",
  fillRule: "nonzero",
  d: "M114.182 293.264l61.663 35.585 14.63-15.446V251.61l-16.154 9.942-60.14-34.422z"
}), React.createElement("path", {
  fill: "#BA3543",
  fillRule: "nonzero",
  d: "M190.476 286.438l-.17 33.877-14.611 8.506.237-52.282"
}), React.createElement("path", {
  fill: "#FB5347",
  fillRule: "nonzero",
  d: "M190.305 320.315l55.455 33.025.037-69.129-55.349-33.238z"
}), React.createElement("path", {
  fill: "#222350",
  fillRule: "nonzero",
  d: "M235.319 294.839l39.168-39.36-124.156-67.944-38.274 38.657z"
}), React.createElement("path", {
  fill: "#014163",
  fillRule: "nonzero",
  d: "M235.319 294.839l-84.988-107.304-38.274 38.657z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M267.922 310.728l.667-.386v-10.586l-.667.386z"
}), React.createElement("path", {
  fill: "#F6E7DB",
  fillRule: "nonzero",
  d: "M235.214 294.8l-123.157-68.608v2.986l123.753 68.95 2.381-3.328z"
}), React.createElement("path", {
  fill: "#BA3543",
  fillRule: "nonzero",
  opacity: 0.37,
  d: "M190.477 286.438l44.738 24.491 10.573-5.632-10.573 18.09-44.738-26.624z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M155.891 295.698l13.523 7.833v-.772l-13.523-7.833z"
}), React.createElement("path", {
  fill: "#F6EBDF",
  fillRule: "nonzero",
  d: "M156.309 295.253l12.656 7.331v-25.915l-12.656-7.331z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M158.088 282.83l9.182 5.319v-10.477l-9.182-5.319zM158.014 294.965l9.182 5.319v-11.075l-9.182-5.319z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M167.299 288.165l-2.223-1.272-.886-8.909-4.551-2.637-1.551 6.024-.004-9.019 9.215 5.336zM167.276 300.329l.023-11.062-9.215-5.336v10.087l1.443-7.446 3.992 2.297 1.032 9.882z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M136.84 285.799l13.523 7.833v-.771l-13.523-7.834z"
}), React.createElement("path", {
  fill: "#F6EBDF",
  fillRule: "nonzero",
  d: "M137.256 285.354l12.656 7.331V266.77l-12.656-7.331z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M139.035 272.931l9.183 5.319v-10.477l-9.183-5.318zM138.963 285.066l9.182 5.319V279.31l-9.182-5.319z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M148.246 278.266l-2.222-1.271-.887-8.91-4.551-2.637-1.55 6.025-.005-9.02 9.215 5.337zM148.223 290.43l.023-11.061-9.215-5.337v10.087l1.444-7.446 3.991 2.297 1.032 9.882z"
}), React.createElement("path", {
  fill: "#F7E8DC",
  fillRule: "nonzero",
  d: "M196.684 324.07v-34.219l42.696 23.467v36.267z"
}), React.createElement("path", {
  fill: "#070634",
  fillRule: "nonzero",
  d: "M114.182 291.466l61.52 35.697 14.603-8.512 6.379 3.755v1.664l-6.379-3.755-14.63 8.534-61.493-35.243z"
}), React.createElement("path", {
  fill: "#BA3543",
  fillRule: "nonzero",
  d: "M196.684 324.07l.765-.427v-33.387l-.765-.405z"
}), React.createElement("path", {
  fill: "#F6E7DB",
  fillRule: "nonzero",
  d: "M232.576 310.587l2.637 1.451v51.2l-2.637-1.536z"
}), React.createElement("path", {
  fill: "#E6CACD",
  fillRule: "nonzero",
  d: "M237.441 309.583l-2.228 1.431-2.637-1.451v1.902l2.637 1.39v50.383l2.636-1.194z"
}), React.createElement("path", {
  fill: "#F6E7DB",
  fillRule: "nonzero",
  d: "M119.71 261.435V294.8l11.313 6.401-.036-33.692z"
}), React.createElement("path", {
  fill: "#BA3543",
  fillRule: "nonzero",
  opacity: 0.37,
  d: "M235.298 298.128l-.255 4.438-120.861-68.039v-4.163z"
}), React.createElement("path", {
  fill: "#F6EBDF",
  fillRule: "nonzero",
  d: "M119.71 260.155v1.365l11.313 6.23v-1.28z"
}), React.createElement("path", {
  fill: "#E6CACD",
  fillRule: "nonzero",
  d: "M131.023 301.2l1.058.652-.037-34.871-1.021-.512z"
}), React.createElement("path", {
  fill: "#BA3543",
  fillRule: "nonzero",
  d: "M247.035 304.87l-11.822 6.144.105-13.159 10.479-10.438z"
}), React.createElement("path", {
  fill: "#F6E7DB",
  fillRule: "nonzero",
  d: "M235.213 294.8l1.871 1.536 37.424-38.315 14.116 7.234 1.023-1.516-15.139-8.278z"
}), React.createElement("path", {
  fill: "#E6CACD",
  fillRule: "nonzero",
  d: "M118.52 294.032l1.19.769v-34.646l-1.19-.683zM112.992 270.052l-1.191-.681 1.19.681z"
}), React.createElement("path", {
  fill: "#014163",
  fillRule: "nonzero",
  d: "M119.719 261.435l-9.96 7.886 12.5 6.535 9.019-7.975z"
}), React.createElement("path", {
  fill: "#222350",
  fillRule: "nonzero",
  d: "M119.719 261.435l-9.96 7.886 21.519-1.44z"
}), React.createElement("path", {
  fill: "#070634",
  fillRule: "nonzero",
  d: "M239.381 348.134v1.451l6.379 3.755 17.861-10.667.681-1.963-18.505 11.236z"
}), React.createElement("path", {
  fill: "#EFA554",
  fillRule: "nonzero",
  d: "M301.98 290.278h2.722v57.515h-2.722z"
}), React.createElement("path", {
  fill: "#D37F54",
  fillRule: "nonzero",
  d: "M301.98 347.196V289.68h2.722z"
}), React.createElement("path", {
  fill: "#FFA26E",
  fillRule: "nonzero",
  d: "M295.858 314.513l6.124 6.379.04 1.702-8.715-8.849z"
}), React.createElement("path", {
  d: "M270.981 316.305c9.395 0 17.011-7.642 17.011-17.067 0-9.426-7.616-17.067-17.011-17.067-9.394 0-17.01 7.641-17.01 17.067 0 9.425 7.616 17.067 17.01 17.067z",
  fill: "url(#step-section-estate_svg__E)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M286.989 307.094a18.024 18.024 0 006.316 7.01l9.171-14.295s-10.006-.759-17.471-1.401a18.114 18.114 0 001.984 8.686z",
  fill: "#02846E",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M257.645 375.953c14.522 0 26.295-11.423 26.295-25.515 0-14.091-11.773-25.515-26.295-25.515-14.523 0-26.295 11.424-26.295 25.515 0 14.092 11.772 25.515 26.295 25.515z",
  fill: "url(#step-section-estate_svg__F)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M276.676 327.782a26.884 26.884 0 00-10.43 9.458l21.269 13.735s1.127-14.984 2.082-26.163a26.776 26.776 0 00-12.921 2.97z",
  fill: "#00986D",
  fillRule: "nonzero",
  opacity: 0.92
}), React.createElement("path", {
  fill: "#FB5347",
  fillRule: "nonzero",
  d: "M305.554 394.556l-33.927-19.702-.01-16.906 33.937 19.37z"
}), React.createElement("path", {
  d: "M687.873 330.694c7.892 0 14.289-6.419 14.289-14.337 0-7.917-6.397-14.336-14.289-14.336-7.892 0-14.289 6.419-14.289 14.336 0 7.918 6.397 14.337 14.289 14.337z",
  fill: "url(#step-section-estate_svg__G)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M683.667 302.474a14.212 14.212 0 00-6.161 3.631l17.011 11.85s7.711-2.505 6.816-5.642c-2.171-7.611-10.08-12.016-17.666-9.839z",
  fill: "url(#step-section-estate_svg__H)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#EFA554",
  fillRule: "nonzero",
  d: "M685.301 309.222h2.12v44.8h-2.12z"
}), React.createElement("path", {
  fill: "#D37F54",
  fillRule: "nonzero",
  d: "M685.301 353.557v-44.8h2.119z"
}), React.createElement("path", {
  fill: "#FFA26E",
  fillRule: "nonzero",
  d: "M680.53 328.099l4.77 4.969.031 1.326-6.788-6.893z"
}), React.createElement("path", {
  d: "M655.38 328.934c9.466 0 17.139-7.698 17.139-17.195 0-9.496-7.673-17.195-17.139-17.195-9.465 0-17.138 7.699-17.138 17.195 0 9.497 7.673 17.195 17.138 17.195z",
  fill: "url(#step-section-estate_svg__I)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M671.277 319.654a18.166 18.166 0 006.363 7.063l9.24-14.403s-10.08-.768-17.601-1.41a18.244 18.244 0 001.998 8.75z",
  fill: "#01576F",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M390.094 451.503c-.314-3.248-2.098-9.294-10.841-11.035-10.23-2.037-13.548 7.258-14.022 8.794a3.047 3.047 0 00-.04.133l-.022.08c-.603 2.309.841 4.909 4.218 6.865 5.261 3.048 13.219 3.379 17.777.74 2.513-1.459 3.466-3.516 2.93-5.577z",
  fill: "url(#step-section-estate_svg__J)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#ED9A76",
  fillRule: "nonzero",
  d: "M374.955 448.317l33.609-19.526 1.178-61.03-34.447 19.115z"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__K)",
  fillRule: "nonzero",
  d: "M514.318 468.157l-65.964 37.12.085-98.219 65.964-37.12z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#7486B9",
  fillRule: "nonzero",
  d: "M479.502 494.615v-3.985l54.36-31.488v3.984zM479.502 467.479v-3.984l65.672-37.974v3.984zM479.354 457.921v-3.983l65.671-37.974v3.983zM479.502 422.251v-3.983l65.672-37.974v3.984zM479.502 413.206v-3.984l65.672-37.973v3.983zM479.354 485.655v-3.984l54.58-31.616v3.983zM479.354 476.609v-3.983l65.892-38.102-.098 5.003zM481.047 448.495l-3.719-1.807 68.065-39.389v3.99zM472.797 444.357l-4.459-1.632 77.057-44.599-.147 4.298zM463.394 440.626l-3.794-1.79 85.646-49.541v3.991z"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__L)",
  fillRule: "nonzero",
  d: "M332.219 304.86l97.981 56.756v76.288l-51.967-30.359.34-40.296z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#7486B9",
  fillRule: "nonzero",
  d: "M412.975 394.333v-3.45l51.882 30.054v3.449zM412.975 386.304v-3.45l51.967 30.103v3.45zM412.975 378.339v-3.45l51.967 30.103v3.45zM398.771 353.079l-4.294-5.918 65.532 37.935v3.456zM387.798 337.818l-5.15-6.633 75.916 43.948-.17 3.549zM377.28 323.261l-4.382-5.992 85.835 49.723v3.456z"
}), React.createElement("path", {
  fill: "#014163",
  fillRule: "nonzero",
  d: "M423.34 433.656l-47.926-27.761 34.329-38.048 52.989 29.355z"
}), React.createElement("path", {
  fill: "#222350",
  fillRule: "nonzero",
  d: "M423.834 433.503l-48.367-27.597 82.332-10.838z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M375.391 407.89l48.614 28.16v-2.168l-18.912-10.954-11.333-6.566-.39-.225-11.333-6.565-.457-.265-6.189-3.585zM455.086 472.383l13.523 7.832v-.771l-13.523-7.834z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M434.217 459.521l12.656 7.331v-25.915l-12.656-7.331z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M433.873 460.095l13.524 7.832v-.771l-13.524-7.834z"
}), React.createElement("path", {
  fill: "url(#step-section-estate_svg__M)",
  fillRule: "nonzero",
  d: "M394.764 473.645l51.785 29.995-.003-97.774-25.022-39.812-26.76 11.353z",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#668EBE",
  fillRule: "nonzero",
  d: "M476.151 489.784v-4.401L426.15 456.42v4.401zM476.697 479.684v-4.401l-50.002-28.963v4.401zM476.151 458.45v-4.4l-50.001-28.963v4.401zM476.003 468.861v-4.4l-50.001-28.963v4.4zM477.145 449.317v-4.065l-50.178-29.067v4.066zM478.784 440.219v-4.569l-51.925-30.078v4.571zM478.829 429.695v-4.571l-51.925-30.076v4.569zM478.784 419.073v-4.57l-51.925-30.078v4.571z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M455.283 429.91l12.655 7.331v-25.915l-12.655-7.331z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M453.729 403.757l15.542 9.003v-2.647l-15.542-9.003z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M454.939 430.483l13.524 7.834v-.772l-13.524-7.834z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M434.068 417.622l12.656 7.331v-25.915l-12.656-7.331z"
}), React.createElement("path", {
  fill: "#81D2DB",
  fillRule: "nonzero",
  d: "M435.85 405.2l9.182 5.319v-10.477l-9.182-5.319zM457.062 417.403l9.183 5.319v-10.477l-9.183-5.319z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M435.85 416.779l9.182 5.319v-10.477l-9.182-5.319z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M432.516 391.469l15.541 9.003v-2.647l-15.541-9.003z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M433.727 418.195l13.523 7.834v-.772l-13.523-7.834zM433.506 459.711l13.523 7.832v-.771l-13.523-7.834z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M445.06 410.534l-2.223-1.27-.886-8.911-4.551-2.637-1.551 6.025-.003-9.02 9.214 5.338z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M445.06 422.114v-10.477l-9.214-5.337v10.476l1.442-7.765 5.996 3.472z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M440.952 408.265l-.667-.386v-10.586l.667.385z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M440.285 400.932l3.432 1.988v-.11l-3.432-1.988zM438.369 401.035l3.431 1.987v-.11l-3.431-1.987zM436.551 401.195l3.431 1.987v-.11l-3.431-1.987zM440.588 405.519l3.432 1.988v-.111l-3.432-1.988zM413.826 366.08l12.656 7.331v-25.915l-12.656-7.331z"
}), React.createElement("path", {
  fill: "#81D2DB",
  fillRule: "nonzero",
  d: "M415.605 353.658l9.183 5.319v-10.476l-9.183-5.319z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M415.605 365.237l9.183 5.319v-10.477l-9.183-5.319z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M412.271 339.926l15.542 9.003v-2.646l-15.542-9.003z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M413.482 366.654l13.524 7.833v-.772l-13.524-7.834z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M424.817 358.992l-2.222-1.27-.886-8.911-4.552-2.637-1.55 6.025-.003-9.02 9.213 5.338z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M424.817 370.572v-10.476l-9.213-5.338v10.477l1.442-7.766 5.995 3.472z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M420.71 356.723l-.667-.385v-10.587l.667.386z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M420.043 349.391l3.432 1.987v-.11l-3.432-1.987zM418.125 349.493l3.431 1.987v-.11l-3.431-1.987zM416.309 349.653l3.431 1.988v-.11l-3.431-1.988zM420.346 353.977l3.432 1.988v-.111l-3.432-1.988zM446.724 364.303v-5.201l-12.656-7.331v18.485z"
}), React.createElement("path", {
  fill: "#81D2DB",
  fillRule: "nonzero",
  d: "M435.85 365.264l7.83 4.545 1.352-9.703-9.182-5.319z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M432.516 351.532l15.541 9.003v-2.647l-15.541-9.003z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M445.04 368.871l-2.203.456-.886-8.911-4.551-2.636-1.551 6.024-.003-9.02 9.214 5.338z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M442.573 370.236l-6.727-3.872.008 4.043 1.434-1.332 3.159 1.844z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M440.952 368.329l-.667-.386v-10.587l.667.386z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M440.285 360.996l3.432 1.987v-.11l-3.432-1.987zM438.369 361.098l3.431 1.988v-.11l-3.431-1.988zM436.551 361.259l3.431 1.987v-.11l-3.431-1.987zM440.588 365.583l3.432 1.987v-.11l-3.432-1.988zM509.251 426.667l-12.655 7.331v-25.915l12.655-7.331z"
}), React.createElement("path", {
  fill: "#81D2DB",
  fillRule: "nonzero",
  d: "M507.469 414.245l-9.182 5.319v-10.476l9.182-5.319z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M507.469 425.824l-9.182 5.319v-10.476l9.182-5.319z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M509.594 427.241l-13.524 7.833v-.772l13.524-7.833z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M498.26 419.58l2.221-1.271.887-8.911 4.552-2.636 1.549 6.024.005-9.02-9.214 5.338z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M498.26 431.159v-10.476l9.214-5.338v10.477l-1.444-7.766-5.994 3.473z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M502.367 417.31l.666-.385v-10.587l-.666.386z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M503.035 409.978l-3.431 1.987v-.11l3.431-1.987zM504.951 410.08l-3.431 1.987v-.11l3.431-1.987zM506.767 410.241l-3.431 1.987v-.11l3.431-1.987zM502.732 414.565l-3.431 1.987v-.11l3.431-1.988zM530.768 414.465l-12.655 7.331v-25.915l12.655-7.331z"
}), React.createElement("path", {
  fill: "#81D2DB",
  fillRule: "nonzero",
  d: "M528.989 402.043l-9.182 5.319v-10.477l9.182-5.319z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M528.989 413.621l-9.182 5.319v-10.476l9.182-5.319z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M531.113 415.038l-13.523 7.834v-.772l13.523-7.834z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M519.779 407.377l2.222-1.271.886-8.91 4.552-2.637 1.55 6.024.004-9.02-9.214 5.338z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M519.779 418.957V408.48l9.214-5.337v10.476l-1.443-7.765-5.995 3.472z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M523.887 405.108l.666-.386v-10.587l-.666.386z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M524.552 397.775l-3.431 1.987v-.11l3.431-1.987zM526.471 397.877l-3.432 1.988v-.11l3.432-1.988zM528.287 398.038l-3.432 1.987v-.11l3.432-1.987zM531.79 456.961l-12.655 7.331v-25.915l12.655-7.331z"
}), React.createElement("path", {
  fill: "#81D2DB",
  fillRule: "nonzero",
  d: "M530.009 444.624l-9.183 5.319v-10.476l9.183-5.319z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M530.009 456.118l-9.183 5.319V450.96l9.183-5.319z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M532.305 457.364l-13.524 7.834v-.773l13.524-7.833z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M520.885 449.788l2.221-1.271.887-8.91 4.552-2.637 1.549 6.024.005-9.019-9.214 5.337z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M520.799 461.538v-10.476l9.214-5.338v10.477l-1.444-7.766-5.994 3.472z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M524.992 447.519l.666-.386v-10.586l-.666.385z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M525.658 437.797l-3.431 1.987v-.11l3.431-1.987zM527.576 437.899l-3.431 1.988v-.111l3.431-1.987zM529.392 438.06l-3.431 1.987v-.11l3.431-1.988zM525.355 442.383l-3.431 1.988v-.11l3.431-1.989zM509.421 468.993l-12.655 7.331v-25.915l12.655-7.331z"
}), React.createElement("path", {
  fill: "#81D2DB",
  fillRule: "nonzero",
  d: "M507.639 456.571l-9.182 5.319v-10.477l9.182-5.319z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M507.639 468.15l-9.182 5.319v-10.477l9.182-5.318z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M509.764 469.567L496.24 477.4v-.772l13.524-7.834z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M498.43 461.905l2.221-1.27.887-8.911 4.552-2.637 1.549 6.025.005-9.02-9.214 5.338z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M498.43 473.485v-10.476l9.214-5.338v10.476l-1.444-7.765-5.994 3.472z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M502.537 459.636l.666-.385v-10.587l-.666.386z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M503.204 452.303l-3.431 1.988v-.11l3.431-1.988zM505.121 452.406l-3.432 1.987v-.11l3.432-1.987zM506.937 452.566l-3.431 1.988v-.11l3.431-1.988zM502.902 456.89l-3.431 1.988v-.11l3.431-1.989z"
}), React.createElement("path", {
  fill: "#F6EBDF",
  fillRule: "nonzero",
  d: "M455.283 471.639l12.655 7.331v-25.916l-12.655-7.331z"
}), React.createElement("path", {
  fill: "#81D2DB",
  fillRule: "nonzero",
  d: "M457.062 459.215l9.183 5.319v-10.476l-9.183-5.319z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M456.988 471.351l9.183 5.319v-11.075l-9.183-5.319z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M466.272 464.551l-2.221-1.272-.886-8.91-4.552-2.636-1.55 6.024-.004-9.02 9.213 5.337z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M466.25 476.715l.022-11.062-9.213-5.337v10.088l1.443-7.447 3.992 2.298 1.031 9.881z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M461.383 462.53l-.666-.386v-10.586l.666.385zM461.057 444.445l3.432 1.988v-.11l-3.432-1.989z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M459.582 455.051l3.432 1.988v-.111l-3.432-1.988zM457.766 455.212l3.431 1.987v-.11l-3.431-1.987zM467.939 453.671l1.48-1.83s-2.505-5.035-7.882-8.149c-4.788-2.774-7.66-.768-7.66-.768l1.407 3.417 12.655 7.33z"
}), React.createElement("path", {
  fill: "#F6EBDF",
  fillRule: "nonzero",
  d: "M433.922 459.265l12.655 7.331v-25.915l-12.655-7.331z"
}), React.createElement("path", {
  fill: "#81D2DB",
  fillRule: "nonzero",
  d: "M435.701 446.842l9.183 5.319v-10.476l-9.183-5.319z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M435.627 458.977l9.182 5.319v-11.074l-9.182-5.319z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M444.912 452.177l-2.222-1.271-.887-8.91-4.551-2.637-1.55 6.025-.005-9.02 9.215 5.337z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M444.889 464.342l.023-11.062-9.215-5.337v10.087l1.444-7.446 3.991 2.297 1.032 9.882z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M440.805 449.908l-.666-.386v-10.586l.666.386z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M440.139 442.575l3.432 1.988v-.11l-3.432-1.989zM438.221 442.677l3.431 1.988v-.111l-3.431-1.987zM436.404 442.838l3.431 1.988v-.111l-3.431-1.987zM446.578 441.298l1.479-1.831s-2.504-5.034-7.881-8.149c-4.788-2.773-7.66-.768-7.66-.768l1.406 3.418 12.656 7.33z"
}), React.createElement("path", {
  d: "M447.614 385.625l6.85 3.968v-11.151c0-.675-.419-1.688-1.07-2.344a11.771 11.771 0 00-2.371-1.814 7.538 7.538 0 00-2.297-.837c-.68-.116-1.117.42-1.117 1.119l.005 11.059z",
  fill: "#F7E7DD",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M453.376 382.16v-3.232c0-.557-.291-1.544-.744-2.036a7.32 7.32 0 00-1.65-1.319c-.481-.278-1.08-.5-1.594-.518-.539-.02-.777.612-.777 1.187v3.158l4.765 2.76z",
  fill: "#A4DEE4",
  fillRule: "nonzero"
}), React.createElement("path", {
  fill: "#13597A",
  fillRule: "nonzero",
  d: "M448.641 385.245l4.764 2.76v-5.449l-4.764-2.761z"
}), React.createElement("path", {
  fill: "#F7E7DD",
  fillRule: "nonzero",
  d: "M450.891 386.674l.297.172v-11.557l-.297-.173z"
}), React.createElement("path", {
  fill: "#FFC47B",
  fillRule: "nonzero",
  d: "M293.846 401.288l9.495 5.471 1.106-.768 58.432 33.451-.085 1.536 12.076 7.073V390.22l-25.446-41.02-15.76-26.223-14.386 8.761-25.358 14.895z"
}), React.createElement("path", {
  fill: "#FFB87B",
  fillRule: "nonzero",
  d: "M304.787 406.162l3.828 2.218-.037-70.238-3.83 1.877zM295.393 402.269l3.798 2.201.032-59.544-3.83 2.363zM313.291 411.196l3.998 2.134.053-80.863-3.831 2.901z"
}), React.createElement("path", {
  fill: "#FFB77B",
  fillRule: "nonzero",
  d: "M322.307 416.231l3.742 2.133.058-91.401-3.83 2.56z"
}), React.createElement("path", {
  fill: "#FFB87B",
  fillRule: "nonzero",
  d: "M331.068 421.18l3.827 2.219-.022-99.124-3.83-1.109zM339.829 426.301l3.827 2.133-.017-89.524-3.83-6.4zM348.59 431.335l3.827 2.134.135-79.924-3.978-6.4zM357.01 436.114l3.828 2.218-.012-70.838-3.826-6.141zM366.137 442.737l3.798 2.285v-63.403l-3.83-5.376z"
}), React.createElement("path", {
  fill: "#F6E7DB",
  fillRule: "nonzero",
  d: "M292.747 400.736l3.094 1.792v-62.175l-3.132 1.296zM372.225 446.577l3.094 1.792V387.08l-3.094-.511z"
}), React.createElement("path", {
  fill: "#F7E8DC",
  fillRule: "nonzero",
  d: "M304.439 405.954l58.438 33.829.287-45.356-58.412-33.835z"
}), React.createElement("path", {
  fill: "#F6E7DB",
  fillRule: "nonzero",
  d: "M295.855 345.574l77.916 45.34v-3.154l-77.916-45.258z"
}), React.createElement("path", {
  fill: "#E08663",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M372.224 386.569l-8.544-4.654-28.87-55.37-35.36 18.066-2.725-1.579 39.481-25.708z"
}), React.createElement("path", {
  fill: "#E6CACD",
  fillRule: "nonzero",
  d: "M323.242 325.679l24.749 14.336-2.284-4.378-19.74-11.631z"
}), React.createElement("path", {
  fill: "#E6CACD",
  fillRule: "nonzero",
  d: "M334.475 329.032l-1.215-.704v-9.169l1.179-.691z"
}), React.createElement("path", {
  fill: "#F7E8DC",
  fillRule: "nonzero",
  d: "M339.152 334.895l-2.357-4.42-4.493-2.701-2.663 1.576z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  opacity: 0.55,
  d: "M363.165 408.714l-58.411-33.835v-.394l58.411 33.835zM363.313 401.705l-58.411-33.835v-.395l58.411 33.835zM363.165 416.006l-58.411-33.835v-.394l58.411 33.835zM363.165 423.297l-58.411-33.835v-.394l58.411 33.835zM363.165 430.096l-58.411-33.835v-.394l58.411 33.835zM363.165 437.191l-58.411-33.835v-.394l58.411 33.835z"
}), React.createElement("path", {
  fill: "#E6CACD",
  fillRule: "nonzero",
  opacity: 0.35,
  d: "M363.134 396.519l-54.807-29.179-3.573 35.331.037-42.108 58.428 33.566z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M405.916 462.567l2.211 1.366-.034-37.97-2.174-1.259z"
}), React.createElement("path", {
  d: "M424.009 448.25s-3.167-8.658-8.323-11.546c-4.933-2.764-7.665 2.664-7.665 2.664v-12.715l15.984 9.259.004 12.338z",
  fill: "#F6E7DB",
  fillRule: "nonzero"
}), React.createElement("path", {
  fill: "#E6CACD",
  fillRule: "nonzero",
  d: "M408.025 427.636l15.984 9.259v-.986l-15.984-9.259z"
}), React.createElement("path", {
  fill: "#F6E7DB",
  fillRule: "nonzero",
  d: "M408.447 459.607l15.616 9.046v-3.066l-15.616-9.046zM409.979 456.126l14.069 8.15v-3.067l-14.069-8.149zM406.916 463.174l17.089 9.899v-3.066l-17.089-9.899z"
}), React.createElement("path", {
  fill: "#01375C",
  fillRule: "nonzero",
  d: "M457.043 429.057l8.839 5.12v-10.496l-8.839-5.12z"
}), React.createElement("path", {
  fill: "#230B40",
  fillRule: "nonzero",
  d: "M466.272 434.402v-10.476l-9.213-5.338v10.476l1.443-7.765 4.139 2.382.589 8.96z"
}), React.createElement("path", {
  fill: "#7E9CB9",
  fillRule: "nonzero",
  d: "M466.272 422.822l-2.221-1.27-.886-8.911-4.552-2.637-1.55 6.025-.004-9.02 9.213 5.338z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M461.809 420.376l-.666-.387v-10.586l.666.385z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M461.312 417.65l3.432 1.988v-.111l-3.432-1.987zM459.582 413.323l3.432 1.987v-.11l-3.432-1.987zM457.766 413.483l3.431 1.988v-.11l-3.431-1.988zM461.359 407.303l3.432 1.988v-.11l-3.432-1.989z"
}), React.createElement("path", {
  d: "M424.041 374.758v98.39l3.289 1.906 48.5 28.09v-.074l3.442 1.993.016-96.086v-2.379l-.063-.026-27.78-44.444-17.477 8.057-9.927 4.573zm3.372 1.981l24.177-10.259 23.718 37.889 3.542 2.052h-.005l-51.432-29.682zm-.058 2.183l-.022 86.125 48.497 28.09v-86.162l-48.475-28.053z",
  fill: "#F6E7DB"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M455.086 471.956l13.523 7.833v-.772l-13.523-7.833z"
}), React.createElement("path", {
  fill: "#E1C1C5",
  fillRule: "nonzero",
  d: "M479.216 497.818l-19.122-3.762 19.137 11.015zM406.936 460.093l1.531-.512 15.596 9.072-.058 1.354zM408.467 456.594l1.531-.512 15.596 9.072-.058 1.354z"
}), React.createElement("path", {
  fill: "#F6E7DB",
  fillRule: "nonzero",
  d: "M292.709 341.649l3.147.853 36.403-21.675-1.191-2.474z"
}), React.createElement("path", {
  fill: "#E6CACD",
  fillRule: "nonzero",
  d: "M298.398 344.002l35.221-20.956-1.361-2.219-36.403 21.675z"
}), React.createElement("path", {
  fill: "#014163",
  fillRule: "nonzero",
  d: "M333.874 316.817l41.421 70.059 2.925-1.62 31.501-17.527.021-2.784-42.161-66.163-33.962 18.035 41.676 70.059"
}), React.createElement("path", {
  fill: "#F6E7DB",
  fillRule: "nonzero",
  d: "M330.812 318.523l2.807-1.706 41.677 70.144-3.641-.17z"
}), React.createElement("path", {
  fill: "#014163",
  fillRule: "nonzero",
  d: "M451.42 362.129l27.983 44.289 65.661-36.95-25.771-45.483z"
}), React.createElement("path", {
  fill: "#222350",
  fillRule: "nonzero",
  d: "M451.42 362.129l27.387 44.289 55.285-31.233z"
}), React.createElement("path", {
  fill: "#E6CACD",
  fillRule: "nonzero",
  d: "M371.128 385.852l1.531 2.731 2.637-1.622-3.062 4.864.054-1.786-7.794-4.614z"
}), React.createElement("path", {
  fill: "#E08663",
  fillRule: "nonzero",
  d: "M379.574 384.505v16.693l3.074-3.407v-14.937zM386.293 379.47v14.281l3.074-3.407V377.82zM392.672 376.398v10.528l3.074-3.59v-8.588zM398.855 371.345l.026 8.413 3.036-3.293v-7.168zM379.574 410.377v35.346l3.197-1.946.01-31.386zM386.719 414.452v27.005l3.196-1.947.008-23.201zM393.523 418.393v19.053l3.197-1.946.005-15.252z"
}), React.createElement("path", {
  fill: "#F6E7DB",
  fillRule: "nonzero",
  d: "M374.051 384.866l33.906-18.924 1.786-.997.045 2.828-34.492 19.189"
}), React.createElement("path", {
  fill: "#222350",
  fillRule: "nonzero",
  d: "M367.557 298.811l6.464 86.017 35.722-19.883zM376.636 312.704l80.354 46.545 30.152-16.661-92.028-52.31-18.718 20.524z"
}), React.createElement("path", {
  fill: "#F6E7DB",
  fillRule: "nonzero",
  d: "M477.547 405.866l.002 2.576 67.854-38.462-.34-2.646z"
}), React.createElement("path", {
  fill: "#E08663",
  fillRule: "nonzero",
  opacity: 0.39,
  d: "M303.34 406.759l1.106-.597.34-45.569-1.106-.683z"
}), React.createElement("path", {
  fill: "#F6E7DB",
  fillRule: "nonzero",
  d: "M376.487 312.721l-.085-1.878 1.288.743 80.874 46.603-1.871 1.039z"
}), React.createElement("path", {
  fill: "#E1C1C5",
  fillRule: "nonzero",
  d: "M424.048 461.209l-.016-11.186-14.034 3.072z"
}), React.createElement("path", {
  fill: "#F4E8DB",
  fillRule: "nonzero",
  d: "M524.589 402.276l-3.431 1.988v-.11l3.431-1.988z"
}), React.createElement("path", {
  d: "M565.264 483.133c10.358 0 18.754-8.424 18.754-18.816s-8.396-18.817-18.754-18.817-18.754 8.425-18.754 18.817 8.396 18.816 18.754 18.816z",
  fill: "#02846E",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M565.266 445.671a18.627 18.627 0 00-9.082 2.351l17.204 21.116s10.632-.367 10.632-4.651c0-10.391-8.397-18.816-18.754-18.816z",
  fill: "#00A872",
  fillRule: "nonzero",
  opacity: 0.59
}), React.createElement("path", {
  d: "M537.283 502.76c16.934 0 30.662-13.773 30.662-30.763 0-16.99-13.728-30.763-30.662-30.763-16.934 0-30.662 13.773-30.662 30.763 0 16.99 13.728 30.763 30.662 30.763z",
  fill: "#008187",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M496.112 442.884c-11.935 4.206-20.491 15.616-20.491 29.027 0 16.99 13.728 30.763 30.662 30.763a30.5 30.5 0 0020.959-8.309c-10.784-17.385-22.588-36.705-31.13-51.481z",
  fill: "url(#step-section-estate_svg__N)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M531.311 454.485a30.672 30.672 0 00-7.288-7.326c-7.082 15.536-15.974 36.367-23.88 55.246a30.503 30.503 0 0023.871-5.035c13.818-9.821 17.085-29.021 7.297-42.885z",
  fill: "url(#step-section-estate_svg__O)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M470.688 512.146c10.475 0 18.967-8.519 18.967-19.029s-8.492-19.03-18.967-19.03c-10.476 0-18.967 8.52-18.967 19.03 0 10.51 8.491 19.029 18.967 19.029z",
  fill: "url(#step-section-estate_svg__i)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M510.965 514.638c.311-1.039.269-2.133-.118-3.217-.574-3.982-3.042-10.448-12.817-12.395-10.962-2.182-15.257 6.571-16.415 9.669-.14.308-.248.63-.323.961l-.026.093h.005c-.555 2.686 1.179 5.666 5.08 7.925 6.262 3.628 15.734 4.021 21.161.88 1.86-1.078 3.002-2.431 3.447-3.891h.005l.001-.025z",
  fill: "url(#step-section-estate_svg__P)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#070634",
  fillRule: "nonzero",
  d: "M524.346 515.669v15.569l.957-.554v-14.486l43.68-25.301v14.485l.883-.512v-15.569z"
}), React.createElement("path", {
  fill: "#070634",
  fillRule: "nonzero",
  d: "M525.298 515.242l.034 15.251-.992-.236v-14.486l-43.679-25.301v14.485l-.884-.512v-15.569zM530.689 512.866l.026 15.153.995-.598V511.89zM536.389 509.538l.025 15.153.995-.598v-15.531zM541.578 506.466l.026 15.153.995-.598V505.49zM546.766 503.394l.025 15.153.995-.598v-15.531zM552.465 500.066l.025 15.152.995-.597V499.09zM557.652 496.994l.026 15.152.995-.597v-15.531zM562.756 494.092l.025 15.153.996-.597v-15.531z"
}), React.createElement("path", {
  fill: "#070634",
  fillRule: "nonzero",
  d: "M519.378 512.781l-.025 15.152-.996-.597v-15.531zM513.679 509.452l-.026 15.153-.995-.597v-15.531zM508.491 506.38l-.025 15.153-.995-.597v-15.531zM503.304 503.308l-.026 15.153-.995-.597v-15.531zM497.605 499.98l-.026 15.153-.995-.597v-15.531zM492.417 496.908l-.025 15.153-.996-.597v-15.531zM487.314 494.092l-.026 15.153-.995-.597v-15.531z"
}), React.createElement("path", {
  d: "M396.946 489.523a4.27 4.27 0 00-.074-2.127c-.392-3.304-2.318-9.057-10.811-10.752-8.878-1.767-12.55 5.001-13.676 7.824-1.399 2.531-.071 5.633 3.811 7.878 5.26 3.048 13.219 3.379 17.776.739 1.581-.916 2.544-2.069 2.909-3.312l.044.007.021-.257z",
  fill: "url(#step-section-estate_svg__Q)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M547.699 344.494c-.313-3.248-2.097-9.294-10.84-11.035-10.23-2.037-13.547 7.257-14.022 8.794-.014.044-.028.085-.04.133l-.023.08c-.603 2.309.842 4.909 4.219 6.865 5.261 3.048 13.219 3.379 17.776.74 2.514-1.459 3.466-3.516 2.93-5.577z",
  fill: "url(#step-section-estate_svg__R)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M581.637 361.731c-.314-3.248-2.097-9.293-10.841-11.035-10.229-2.037-13.546 7.258-14.022 8.794-.014.045-.027.086-.04.134l-.022.079c-.604 2.309.841 4.909 4.218 6.865 5.261 3.048 13.22 3.379 17.776.74 2.514-1.459 3.467-3.516 2.931-5.577z",
  fill: "url(#step-section-estate_svg__S)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M600.774 474.97c-.314-3.248-2.098-9.294-10.841-11.036-10.23-2.037-13.547 7.258-14.022 8.795a3.047 3.047 0 00-.04.133l-.022.079c-.604 2.31.841 4.91 4.218 6.866 5.261 3.048 13.219 3.379 17.776.739 2.514-1.458 3.466-3.515 2.931-5.576z",
  fill: "url(#step-section-estate_svg__T)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M667.711 406.446c-.314-3.247-2.097-9.293-10.841-11.035-10.229-2.037-13.546 7.258-14.022 8.794-.013.045-.027.086-.04.134-.012.047-.022.078-.022.079-.604 2.309.841 4.909 4.218 6.865 5.261 3.048 13.22 3.379 17.776.74 2.514-1.458 3.467-3.516 2.931-5.577z",
  fill: "url(#step-section-estate_svg__U)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M616.639 381.319a4.259 4.259 0 00-.074-2.127c-.391-3.304-2.318-9.057-10.81-10.752-8.879-1.767-12.551 5.001-13.676 7.825-1.4 2.53-.072 5.632 3.809 7.877 5.262 3.048 13.22 3.379 17.777.74 1.581-.917 2.544-2.07 2.908-3.313l.045.008.021-.258z",
  fill: "url(#step-section-estate_svg__V)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M255.967 399.876c-.314-3.248-2.098-9.294-10.841-11.036-10.23-2.037-13.548 7.259-14.022 8.795a3.047 3.047 0 00-.04.133l-.022.079c-.603 2.31.841 4.91 4.218 6.866 5.261 3.048 13.219 3.379 17.777.739 2.513-1.458 3.466-3.515 2.93-5.576z",
  fill: "url(#step-section-estate_svg__W)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M393.847 254.343c-.734-3.343-3.123-7.975-10.595-9.463-7.279-1.451-11.057 2.839-12.804 5.987-2.628 2.681-1.558 6.427 2.939 9.032 5.261 3.048 13.219 3.379 17.776.739 1.306-.756 2.189-1.674 2.663-2.67l.29.048c.033-.338.045-.679.038-1.019.177-.864.07-1.763-.307-2.654z",
  fill: "url(#step-section-estate_svg__X)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M429.096 275.505a4.259 4.259 0 00-.074-2.127c-.391-3.304-2.318-9.057-10.81-10.752-8.879-1.767-12.551 5.001-13.676 7.824-1.4 2.531-.072 5.632 3.81 7.878 5.261 3.048 13.219 3.379 17.776.739 1.582-.916 2.544-2.069 2.909-3.312l.045.007.02-.257z",
  fill: "url(#step-section-estate_svg__Y)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M221.519 379.822c-.313-3.248-2.097-9.293-10.84-11.035-10.23-2.037-13.548 7.258-14.022 8.794-.014.045-.028.086-.04.134l-.022.079c-.604 2.309.841 4.909 4.218 6.865 5.261 3.048 13.219 3.379 17.776.74 2.514-1.458 3.466-3.516 2.93-5.577z",
  fill: "url(#step-section-estate_svg__Z)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M133.744 329.39c-.314-3.248-2.097-9.294-10.841-11.036-10.229-2.037-13.547 7.259-14.022 8.795-.013.044-.027.085-.04.133l-.022.079c-.603 2.309.841 4.91 4.219 6.865 5.26 3.049 13.219 3.38 17.776.74 2.513-1.458 3.466-3.515 2.93-5.576z",
  fill: "url(#step-section-estate_svg__aa)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M67.572 292.696c-.314-3.248-2.097-9.294-10.84-11.035-10.23-2.037-13.548 7.258-14.023 8.794-.013.045-.027.086-.04.133-.012.048-.022.079-.022.08-.603 2.309.841 4.909 4.219 6.865 5.26 3.048 13.219 3.379 17.776.74 2.513-1.459 3.466-3.516 2.93-5.577z",
  fill: "url(#step-section-estate_svg__ab)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M334.792 216.147c.428-3.519-4.252-6.988-10.453-7.746-6.202-.758-11.575 1.48-12.003 5-.428 3.52 4.253 6.988 10.454 7.747 6.201.758 11.575-1.481 12.002-5.001z",
  fill: "url(#step-section-estate_svg__ac)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M312.422 212.909s2.627-10.026 12.578-8.045c10.843 2.159 9.703 11.732 9.703 11.732",
  fill: "url(#step-section-estate_svg__ad)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M258.052 175.037c-.28-2.902-1.871-8.301-9.682-9.856-9.131-1.817-12.095 6.472-12.522 7.851l-.037.125-.02.068c-.538 2.062.751 4.385 3.768 6.132 4.698 2.722 11.806 3.017 15.875.661 2.244-1.302 3.094-3.139 2.618-4.981z",
  fill: "url(#step-section-estate_svg__ae)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M198.261 143.463c-.28-2.902-1.871-8.301-9.682-9.855-9.131-1.818-12.095 6.471-12.522 7.85-.014.042-.025.086-.037.125l-.02.068c-.538 2.063.751 4.386 3.768 6.132 4.698 2.722 11.806 3.018 15.875.661 2.244-1.302 3.094-3.139 2.618-4.981z",
  fill: "url(#step-section-estate_svg__af)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  fill: "#FB5347",
  fillRule: "nonzero",
  d: "M491.905 245.989l-33.851-19.371-.085-17.493 33.936 19.2z"
}), React.createElement("path", {
  fill: "#BA3543",
  fillRule: "nonzero",
  d: "M483.656 223.717l8.275 17.541-.025-13.104z"
}), React.createElement("path", {
  fill: "#070634",
  fillRule: "nonzero",
  opacity: 0.36,
  d: "M488.503 226.471l.17 17.658-.853-.488v-17.605zM483.316 223.569l.17 17.659-.853-.489v-17.604zM478.382 220.668l.17 17.658-.853-.488v-17.604zM473.874 218.108l.17 17.658-.853-.488v-17.604zM469.111 215.377l.17 17.658-.853-.488v-17.604zM464.519 212.817l.17 17.659-.853-.489v-17.604z"
}), React.createElement("path", {
  d: "M432.967 254.064c7.891 0 14.289-6.419 14.289-14.337 0-7.917-6.398-14.336-14.289-14.336-7.892 0-14.289 6.419-14.289 14.336 0 7.918 6.397 14.337 14.289 14.337z",
  fill: "url(#step-section-estate_svg__ag)",
  fillRule: "nonzero",
  transform: "translate(31)"
}), React.createElement("path", {
  d: "M459.759 225.844a14.209 14.209 0 00-6.161 3.632l17.01 11.85s7.711-2.505 6.817-5.643c-2.171-7.61-10.08-12.015-17.666-9.839z",
  fill: "#00986D",
  fillRule: "nonzero",
  opacity: 0.39
}));

var SvgStepSectionEstate = function SvgStepSectionEstate(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 816 619"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/step-section-estate.3a6db204.svg";
export { SvgStepSectionEstate as ReactComponent };